import { Component, Inject, OnInit, OnDestroy, OnChanges, SimpleChanges, PLATFORM_ID, input, Output, AfterViewInit, ElementRef, ViewChild, QueryList, ViewChildren, NgZone, ChangeDetectorRef, signal, effect, Input, EventEmitter, Injector, runInInjectionContext, HostListener, computed, inject } from "@angular/core";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from "../../share/shared.module";
import { PageSectionService } from '../../services/PageSection.service';
import { isPlatformBrowser } from "@angular/common";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppStateService } from "src/app/services/app-state.service";
import { MessageService } from "src/app/message.service";
import { AddExperience } from "src/app/services/AddExperience.service";
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Experience } from "src/app/services/experience.service";
import { FilterService } from 'primeng/api';
import { MainService } from "src/app/main.service";
import { GiftIdeasBridgeService } from "src/app/services/GiftIdeasBridge.service";
import { LocationRegionBridgeService } from "src/app/services/locationRegionBridge.service";
import { HighLevelCategoryBridgeService } from "src/app/services/HighLevelCategoryBridge.service";
import { GiftIdeasCategoryBridgeService } from "src/app/services/GiftIdeasCategoryBridge.service";
import { LocationRegionCategoryService } from "src/app/services/LocationRegionCategoryBridge.service";
import { navigateBadgeBrowse } from 'src/app/utils/reward-badge-browse';
import * as globalConstant from '../../global_constant';
import { PaginatorModule } from 'primeng/paginator';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MatSelectModule } from '@angular/material/select';
import { ViewportScroller, Location, DatePipe } from '@angular/common';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { SpurTrustBarComponent } from '../spur-trust-bar/spur-trust-bar.component';
import { CanonicalService } from 'src/app/services/canonical.service';

@Component({
    selector: 'app-exp-cards',
    standalone: true,
    imports: [
        SharedModule,
        PaginatorModule,
        MatSelectModule,
        SpurTrustBarComponent
    ],
    templateUrl: './exp-cards.component.html',
    styleUrls: ['./exp-cards.component.css'],
    providers: [DatePipe],
})

export class ExpCardsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @ViewChild('videoElement', { static: false }) videoElement: ElementRef;
    @ViewChildren('videoElement') videos!: QueryList<ElementRef<HTMLVideoElement>>;
    @ViewChild(GoogleMap, { static: false }) googleMap: GoogleMap;
    @ViewChild('mapCanvasWrap', { static: false }) mapCanvasWrap?: ElementRef<HTMLElement>;
    @ViewChild('mapStickyCol', { static: false }) mapStickyCol?: ElementRef<HTMLElement>;
    @ViewChild('stickyMap', { static: false }) stickyMapEl?: ElementRef<HTMLElement>;
    /** static = in-flow; fixed = pinned under header; bottom = clamped to end of list column */
    mapStickyState: 'static' | 'fixed' | 'bottom' = 'static';
    /** Holds layout space while the map is position:fixed/absolute */
    mapStickySpacerPx = 0;
    private readonly mapStickyTopGap = 110;
    /** Locked map box size while stuck — keeps dimensions identical to in-flow */
    private mapStickyLockW = 0;
    private mapStickyLockH = 0;
    private mapStickyLockCanvasH = 0;
    private mapStickyRaf = 0;
    private mapStickyListening = false;
    private readonly onMapStickyScroll = () => this.scheduleMapStickyUpdate();
    mapDragEndEvent: google.maps.MapsEventListener;
    private mapZoomListener: google.maps.MapsEventListener | null = null;
    private mapDragStartListener: google.maps.MapsEventListener | null = null;
    private mapIdleSearchListener: google.maps.MapsEventListener | null = null;
    private mapResizeObserver: ResizeObserver | null = null;
    /** True while we programmatically change camera (fitBounds / resize restore) — ignore zoom_changed */
    private mapProgrammaticMove = false;
    /** Set on real user drag/zoom; cleared after idle search fires */
    private userMapGesture = false;
    /** Ignore zoom_changed briefly while sticky resize restores the same camera */
    private ignoreZoomSearchUntil = 0;
    private mapResizeGuardTimer: ReturnType<typeof setTimeout> | null = null;
    /** Last stable camera used to detect sticky resize vs real user move */
    private lastStableCamera: { lat: number; lng: number; zoom: number } | null = null;
    @Output() searchedItemChange = new EventEmitter<any>();
    /** Parent should show in-place 404 UI on the same URL (do not navigate away). */
    @Output() routeNotFound = new EventEmitter<void>();
    @Input() is_booking!: number;
    @Input() isUserLogin: boolean = false;
    @Input() authUser!: any;
    @Input() token!: any;
    @Input() slug!: any;
    @Input() selected_date!: any;
    @Input() totalRecord!: any;
    @Input() isGiftIdeasPage!: boolean;
    @Input() isGiftCategoryPage!: boolean;
    /** Draft gift/blog preview: skip published-only list checks that would 404 */
    @Input() isPreview: boolean = false;
    @Input() isLocationRegionPage!: boolean;
    @Input() isLocationRegionCategoryPage!: boolean;
    @Input() isHighLevelCategoryPage!: boolean;

    /** Country names from the listing resolver, so the sidebar is in the first HTML. */
    @Input()
    set filterCountries(value: any[] | null | undefined) {
        if (Array.isArray(value) && value.length > 0 && !this.countries?.length) {
            this.countries = value;
        }
    }

    /** Page category list from the listing resolver. */
    @Input()
    set filterCategories(value: any[] | null | undefined) {
        if (!Array.isArray(value) || value.length === 0) {
            return;
        }
        this.applyResolvedCategories(value);
    }

    /** Higher-level categories when the page list is a different type (gift pages). */
    @Input()
    set filterHighLevel(value: any[] | null | undefined) {
        if (Array.isArray(value) && value.length > 0 && !this.highLevelCategoryList?.length) {
            this.highLevelCategoryList = value;
        }
    }

    /** Experience FAQs for sidebar accordion (location/category pages). Hidden when empty. */
    @Input() experienceFaqs: Array<{ id?: number; question: string; answer: string }> = [];
    /** Optional long description shown above Buy Gift Card. Hidden when empty. */
    @Input() longDescription: string = '';
    private sanitizer = inject(DomSanitizer);

    get trustedLongDescription(): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(this.longDescription || '');
    }
    openExperienceFaqId: number | string | null = null;
    @Output() getAllExperinceData = new EventEmitter<any>();
    @Output() experienceDataChange = new EventEmitter<any[]>();
    @Output() pageChangeFromChild = new EventEmitter<number>();
    @Input() order_by: string = '';
    @Input() order: string = '';
    @Output() order_byChange = new EventEmitter<string>();
    @Output() orderChange = new EventEmitter<string>();
    @Input() price_option: any[] = [];
    @Output() price_optionChange = new EventEmitter<any[]>();
    /** Earn Your Spurs badge filter — passed to parent experience APIs */
    @Input() badge_id: any = '';
    @Output() badge_idChange = new EventEmitter<any>();
    @Input() view_on_map: boolean = false;
    @Output() view_on_mapChange = new EventEmitter<boolean>();
    @Input() lat_long: any = '';
    @Output() lat_longChange = new EventEmitter<any>();
    @Input() mapCenter: { lat?: any; lng?: any } | null = null;
    @Input() pageSize: number = 20;
    /** Items per page in map list column (server-side via get-experience-by-location per_page) */
    readonly mapViewPageSize = 10;

    /** Effective page size for listing + pagination controls */
    get displayPageSize(): number {
        if (this.view_on_map) {
            // Prefer API-reported per_page once loaded; fall back to map list default
            return this.pageSize > 0 ? this.pageSize : this.mapViewPageSize;
        }
        return this.pageSize;
    }

    /** Full result count from API (server-side pagination for map + list). */
    get mapListTotalItems(): number {
        return this.totalRecord || 0;
    }

    get mapRangeFrom(): number {
        if (!this.mapListTotalItems) {
            return 0;
        }
        return ((this.page || 1) - 1) * this.displayPageSize + 1;
    }

    get mapRangeTo(): number {
        if (!this.mapListTotalItems) {
            return 0;
        }
        return Math.min((this.page || 1) * this.displayPageSize, this.mapListTotalItems);
    }

    get mapTotalPages(): number {
        return Math.max(1, Math.ceil(this.mapListTotalItems / this.displayPageSize));
    }

    /** Visible page number buttons (max 5), centered on current page. */
    get mapPageNumbers(): number[] {
        const total = this.mapTotalPages;
        const current = this.page || 1;
        const maxButtons = 5;
        let start = Math.max(1, current - Math.floor(maxButtons / 2));
        let end = Math.min(total, start + maxButtons - 1);
        start = Math.max(1, end - maxButtons + 1);
        const pages: number[] = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    }


    /** Crawlable list pagination (max 7 page links centered on current). */
    get seoPageNumbers(): number[] {
        const total = this.seoLastPage;
        const current = this.page || 1;
        const maxButtons = 5;
        let start = Math.max(1, current - Math.floor(maxButtons / 2));
        let end = Math.min(total, start + maxButtons - 1);
        start = Math.max(1, end - maxButtons + 1);
        const pages: number[] = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    }

    get seoLastPage(): number {
        return Math.max(1, Math.ceil((Number(this.totalRecord) || 0) / (this.rows || 30)));
    }

    /** Absolute path for listing page N (page 1 omits /page-N), with active listing filters in the query. */
    seoPageHref(pageNum: number): string {
        const n = Math.max(1, Number(pageNum) || 1);
        const pageSlug = n > 1 ? `page-${n}` : null;
        let path = '';
        if (this.isGiftCategoryPage || this.isGiftIdeasPage) {
            const country = this.country_slug || (this.giftCategory as any)?.country_slug?.() || '';
            const state = this.state_slug || (this.giftCategory as any)?.state?.() || '';
            path = '/' + ['gifts', this.slug, country, state, pageSlug].filter(Boolean).join('/');
        } else if (this.isLocationRegionCategoryPage) {
            const parts = (this.router?.url || '').split('?')[0].split('/').filter(Boolean);
            const base = parts[0] === 'location-region' ? parts.slice(0, 4) : ['location-region'];
            const cleaned = base.filter((p) => !/^page-\d+$/i.test(p));
            if (pageSlug) {
                cleaned.push(pageSlug);
            }
            path = '/' + cleaned.join('/');
        } else if (this.isLocationRegionPage) {
            const parts = (this.router?.url || '').split('?')[0].split('/').filter(Boolean);
            const cleaned = parts
                .filter((p) => !/^page-\d+$/i.test(p))
                .slice(0, 3);
            if (pageSlug) {
                cleaned.push(pageSlug);
            }
            path = '/' + (cleaned.length ? cleaned.join('/') : ['location-region', this.slug].filter(Boolean).join('/'));
        } else {
            const parts = (this.router?.url || '').split('?')[0].split('/').filter(Boolean);
            const cleaned = parts.filter((p) => !/^page-\d+$/i.test(p));
            if (!cleaned.length) {
                path = '/' + ['experience', this.slug, pageSlug].filter(Boolean).join('/');
            } else {
                if (pageSlug) {
                    cleaned.push(pageSlug);
                }
                path = '/' + cleaned.join('/');
            }
        }
        return this.withListingQuery(path);
    }

    /** Keep tab/date/sort/badge filters on crawlable paginator hrefs (new tab / share). */
    private withListingQuery(path: string): string {
        const params = new URLSearchParams();
        if (Number(this.is_booking) > 0) {
            params.set('is_booking', String(this.is_booking));
        }
        if (this.start_date) {
            params.set('start_date', String(this.start_date));
        }
        if (this.end_date) {
            params.set('end_date', String(this.end_date));
        }
        if (this.selected_date) {
            params.set('date', String(this.selected_date));
        }
        if (this.badge_id != null && this.badge_id !== '') {
            params.set('badge_id', String(this.badge_id));
        }
        if (this.order_by) {
            params.set('order_by', String(this.order_by));
            if (this.order) {
                params.set('order', String(this.order));
            }
        }
        // Preserve marketing / tracking params already on the URL.
        if (this.isBrowser && typeof window !== 'undefined') {
            const current = new URLSearchParams(window.location.search);
            ['gclid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
                const value = current.get(key);
                if (value && !params.has(key)) {
                    params.set(key, value);
                }
            });
        }
        const query = params.toString();
        return query ? `${path}?${query}` : path;
    }

    /**
     * Same behavior as p-paginator onPageChange; keep real href for SEO / new-tab.
     * Uses native href (not routerLink) so preventDefault actually stops navigation and
     * the parent can change page in-place without remounting / clearing filters.
     */
    onSeoPageClick(event: MouseEvent, pageNum: number): void {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        const target = Math.max(1, Math.min(this.seoLastPage, Number(pageNum) || 1));
        if (target === (this.page || 1)) {
            return;
        }
        this.pageChangeFromChild.emit(target);
        this.updateParamsAndScroll();
    }



    @Input() start_date: any = '';
    @Output() start_dateChange = new EventEmitter<any>();
    @Input() end_date: any = '';
    @Output() end_dateChange = new EventEmitter<any>();
    @Output() dateRangeChange = new EventEmitter<{ start_date: any; end_date: any }>();
    selectedDate: Date | null = null;
    selectedDateRange: Date[] = [];
    dateCustomClasses: DatepickerDateCustomClasses[] = [];
    minDate = new Date();
    maxDate: Date;
    private suppressDateEmit = false;
    private _picker: BsDatepickerDirective;
    enable_rfp_225: any = globalConstant.ENABLE_RFP_225;
    search_with_map: boolean = false;
    currentIW: any = '';
    previousIW: any = '';
    fitbounds: boolean = false;
    highlightedMapIndex: number | null = null;
    /** Default experience photo when listing image is missing */
    private readonly defaultMapPinPhoto = 'assets/images/vebolife_img.jpg';
    /** Exact Figma pin body (no tip ring) — photo is drawn on top of this path */
    private readonly mapPinPathD =
        'M50.4206 25.2296C50.4206 30.1624 48.978 35.1223 46.0313 39.4415L25.2103 69.9543L4.38938 39.4415C-2.44494 29.4257 -1.18668 15.962 7.38403 7.38735C12.3067 2.46245 18.7585 0 25.2103 0C31.6621 0 38.114 2.46245 43.0366 7.38735C47.9115 12.2643 50.4206 18.7233 50.4206 25.2296Z';
    private readonly mapPinViewW = 51;
    private readonly mapPinViewH = 70;
    /** Center of the pin bulb (from SVG path) */
    private readonly mapPinPhotoCx = 25.2103;
    private readonly mapPinPhotoCy = 23.5;
    /** Photo circle radius inside the 51×70 pin (larger = bigger image on pin) */
    private readonly mapPinPhotoR = 19;
    /** Cache version — bump when pin artwork changes so stale icons are dropped */
    private readonly mapPinCacheVersion = 'v7';
    /** Composed photo-pin icons keyed by photoUrl|state|version */
    private readonly mapPinIconCache = new Map<string, google.maps.Icon>();
    /** List/map hover — enlarge pin without locking focus */
    hoveredMapIndex: number | null = null;
    mapOptions: google.maps.MapOptions = {
        zoom: 8,
        // Page scroll must NEVER zoom the map. Zoom via +/- controls or Ctrl/Cmd+scroll.
        gestureHandling: 'cooperative',
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
    };
    /**
     * Stable center for <google-map [center]>. Do NOT recompute from experienceData on
     * every CD — that yanksthe camera back to pin[0] after each search-as-I-move fetch.
     */
    mapViewCenter: google.maps.LatLngLiteral = { lat: 39.8283, lng: -98.5795 };
    /** Compact pin detail popup — stays inside the map container */
    mapInfoWindowOptions: google.maps.InfoWindowOptions = {
        maxWidth: 210,
        disableAutoPan: false,
    };
    /** Currently open pin detail (one at a time) */
    private activeInfoWindow: MapInfoWindow | null = null;
    /** Custom in-map popover state (replaces clipped Google InfoWindow) */
    activeMapPinIndex: number | null = null;
    activeMapPinRecord: any = null;
    mapPinPopoverPos: { left: number; top: number; placement: 'above' | 'below' } = {
        left: 12,
        top: 12,
        placement: 'above',
    };
    private readonly mapPinCardWidth = 200;
    private readonly mapPinCardHeight = 200;
    private mapPixelOverlay: google.maps.OverlayView | null = null;
    /** After user focuses a pin/list item, stop auto fitBounds/resize from resetting the view */
    private mapFitLocked = false;
    private mapFitGeneration = 0;
    private mapFitTimers: ReturnType<typeof setTimeout>[] = [];
    /** Debounce + dedupe for "Search as I move the map" API calls */
    private mapSearchDebounceTimer: ReturnType<typeof setTimeout> | null = null;
    private lastSearchedBoundsKey = '';
    private mapMoveListenerReady = false;
    private suppressNextMapIdleSearch = false;
    /**
     * When true, next map data load keeps the current camera (pan/zoom search or map pagination).
     * When false (filters / opening map), fit the map to the newly loaded listing pins.
     */
    private skipFitOnNextMapLoad = false;
    owlExpDetail: OwlOptions = {
        loop: false,
        mouseDrag: false,
        autoplay: false,
        touchDrag: true,
        pullDrag: false,
        dots: false,
        autoWidth: true,
        navSpeed: 700,
        nav: true,
        navText: ["<i class='fas fa-chevron-left cusLeft'></i>", "<i class='fas fa-chevron-right cusRight'></i>"],
        items: 1,
        rewind: false,
        margin: 0,
    };
    experienceData = input.required<any[]>();
    certificate_data = input.required<any[]>();
    sidebarOpen = signal(false);
    sidebarListOpen = signal(false);
    observer!: IntersectionObserver;
    gridView: boolean = true;
    countries: any[] = [];
    selectedChlidLocations: any[] = [];
    isMobileView: boolean = false;
    isTabletOrBelow: boolean = false;
    isBrowser: boolean;
    countrySelected: any;
    citySelected: any;
    selectedCategory: any;
    selectedCategoryName: any;
    selectedCountryIndex: number | null = null;
    selectedCityIndex: number | null = null;
    selectedCategoryIndex: number | null = null;
    highLevelCategoryIndex: number | null = null;
    highLevelCatId: any;
    selectedPrice: string = 'all';
    currentComponentRoute: string = '';
    filteredGroups: any[] = [];
    autocompleteData: any[] = [];
    groupedData: any[] = [];
    Query: any;
    search_id = '';
    type = '';
    modelChanged2: Subject<any> = new Subject<any>();
    highLevelCategoryList: any[] = [];
    categoryList: any;
    catList: any;
    page: any;
    last_page: any;
    current_page: any;
    searchedItem: any;
    location_travel: any;
    at_home: boolean = false;
    selected_location: any;
    price_filter_search: any = [];
    badges: any[] = [];
    selectedBadgeIndex: number | null = null;
    selectedBadgeName: any = null;
    private badgesLoaded = false;
    location: number = 0;
    city: any;
    categorySlug = '';
    categoryIndex: any;
    @Input() isDataLoading: boolean;
    @ViewChild('scrollTargetElement') scrollTarget!: ElementRef;
    locationData: Subscription;
    categoryData: Subscription;
    private breakpointSubs: Subscription[] = [];
    /** Avoid detectChanges before view exists / after destroy (BreakpointObserver emits sync on subscribe). */
    private viewInitialized = false;
    // first: number = 0;
    first = computed(() => {
        let page = 1;
        // Reactively pick the correct service based on the page type
        if (this.isGiftCategoryPage) {
            page = this.giftCategory.page();
        } else if (this.isHighLevelCategoryPage) {
            page = this.bridgeService.page();
        } else if (this.isLocationRegionPage) {
            page = this.locationBridge.page();
        } else if (this.isLocationRegionCategoryPage) {
            page = this.locationCatBdridge.page();
        }

        // Calculate the first (PrimeNG [first] is 0-indexed)
        let first = (page > 0 ? page - 1 : 0) * this.rows;
        return first;
    });
    rows: number = 30;
    country_slug: string = '';
    state_slug: string = '';
    // Collapsible states
    isPriceCollapsed = false;
    isCategoryCollapsed = false;
    isCountryCollapsed = false;
    isCityCollapsed = false;
    isHighLevelCollapsed = false;

    // Session key
    private FILTER_KEY = 'exp_filters';
    private readonly LOCATION_MODAL_LAST_SHOWN_KEY = 'location_modal_last_shown';
    @ViewChild('selectLocationModal', { static: false }) public selectLocationModal: ModalDirective;
    modalLocationList: any[] = [];
    selectedModalItem: any | null = null;
    filteredModalLocationList: any[] = [];
    searchText: string = '';
    @ViewChild('locationModalBox') locationModalBox!: ElementRef<HTMLElement>;
    @ViewChild('locationModalOverlay') locationModalOverlay?: ElementRef<HTMLElement>;
    isLocationModalOpen = false;
    /** Mobile (&lt;768px): first scroll/tap opens the location modal. */
    private locationModalEngageHandler: (() => void) | null = null;
    private locationModalOpenDelayTimer: ReturnType<typeof setTimeout> | null = null;
    private suppressLocationOverlayCloseUntil = 0;
    citiesListData: any[] = [];
    isSelectedFromModal: boolean = false;
    selectedCity: any[] = [];
    placeSlug = '';
    currentHighlvlSlug = '';

    constructor(
        @Inject(PLATFORM_ID) platformId: Object,
        private el: ElementRef,
        private breakpointObserver: BreakpointObserver,
        private ngZone: NgZone,
        private route: ActivatedRoute,
        private cdref: ChangeDetectorRef,
        private state: AppStateService,
        private messageService: MessageService,
        private addexperience: AddExperience,
        private router: Router,
        private experienceService: Experience,
        private filterService: FilterService,
        private mainService: MainService,
        private bridgeService: HighLevelCategoryBridgeService,
        private giftideaBridge: GiftIdeasBridgeService,
        private giftCategory: GiftIdeasCategoryBridgeService,
        private locationBridge: LocationRegionBridgeService,
        private locationCatBdridge: LocationRegionCategoryService,
        private pageSectionService: PageSectionService,
        private injector: Injector,
        private _location: Location,
        private canonicalService: CanonicalService,
        private scroller: ViewportScroller,
        private datePipe: DatePipe
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.maxDate = new Date();
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 2);
        if (this.isBrowser) {
            this.breakpointSubs.push(
                this.breakpointObserver
                    .observe(['(max-width: 991.98px)'])
                    .subscribe(result => {
                        this.isTabletOrBelow = result.matches;
                        if (!this.isTabletOrBelow) {
                            this.closeAllFilterSidebars();
                        }
                        this.syncFilterPinPageClass();
                        this.scheduleMapStickyUpdate();
                        this.safeDetectChanges();
                    })
            );

            this.breakpointSubs.push(
                this.breakpointObserver
                    .observe(['(max-width: 575.98px)'])
                    .subscribe(result => {
                        this.isMobileView = result.matches;
                        // List view only below 575px; force grid above that
                        this.gridView = !this.isMobileView;
                        this.safeDetectChanges();
                    })
            );
            if (typeof localStorage !== 'undefined') {
                if (localStorage.getItem('authUser')) {
                    this.authUser = JSON.parse(localStorage.getItem('authUser'));
                }
            }
        }

        runInInjectionContext(this.injector, () => {
            effect(() => {
                const countriesRecieved = this.state.userData();
                const highLevel = this.state.highLevelCategoryData();
                if (Array.isArray(highLevel) && highLevel.length > 0) {
                    this.highLevelCategoryList = highLevel;
                }
                if (Array.isArray(countriesRecieved) && countriesRecieved.length > 0) {
                    this.countries = countriesRecieved;
                }
            });

            // Signal input — rebuild clean teardrop pins whenever listing data changes
            effect(() => {
                const data = this.experienceData();
                if (!this.view_on_map || !data?.length) {
                    return;
                }
                // Defer so we run after the parent finishes assigning the new array
                queueMicrotask(() => {
                    if (this.view_on_map) {
                        this.resetMapPinStyles();
                    }
                });
            });
        });

        // for High-Level-Category
        effect(() => {
            if (this.isHighLevelCategoryPage) {
                this.type = this.bridgeService.type();
                this.page = this.bridgeService.page();
                this.search_id = this.bridgeService.search_id();
                this.last_page = this.bridgeService.last_page();
                this.current_page = this.bridgeService.current_page();
                this.at_home = this.bridgeService.at_home();
                this.price_filter_search = this.bridgeService.price_filter_search();

                const currentslug = this.bridgeService.slug();
                if (this.highLevelCategoryList && this.highLevelCategoryList.length > 0) {
                    this.highLevelCategoryIndex = this.highLevelCategoryList.findIndex(
                        (cat: any) => cat.slug === currentslug
                    );
                    // if(this.highLevelCategoryIndex == -1){
                    //     this.routeNotFound.emit();
                    //     return;
                    // }
                    this.highLevelCatId = this.highLevelCategoryList[this.highLevelCategoryIndex]
                } else {
                    this.highLevelCategoryIndex = null;
                }

                const countriesList = this.state.userData() || [];
                if (countriesList.length === 0) {
                    return;
                }

                const country_slug = this.bridgeService.countrySlug();

                this.selectedCountryIndex = countriesList.findIndex(
                    (country: any) => country.slug === country_slug
                );

                if (country_slug && this.selectedCountryIndex === -1) {
                    this.routeNotFound.emit();
                    return;
                }

                let selected = countriesList[this.selectedCountryIndex];
                this.countrySelected = selected;

                if (selected?.slug === "united-states") {
                    const divisions = selected.child_locations || [];
                    let merged = divisions.flatMap((d: any) => d.division_data || []);
                    merged = merged.sort((a: any, b: any) => a.name.localeCompare(b.name));
                    this.selectedChlidLocations = merged;
                } else {
                    this.selectedChlidLocations = selected?.child_locations || [];
                }
                const currentCitySlug = this.bridgeService.state();
                if (currentCitySlug) {
                    if (this.selectedChlidLocations && this.selectedChlidLocations.length > 0) {
                        this.selectedCityIndex = this.selectedChlidLocations.findIndex(
                            (place: any) => place.slug === currentCitySlug
                        );

                        if (this.selectedCityIndex === -1) {
                            // const catrgorySlug = this.bridgeService.slug() || 'experience';
                            // this.router.navigate(['experience',catrgorySlug,country_slug,`page-${this.page}`])
                            this.routeNotFound.emit()
                            return;
                        }
                    } else {
                        this.selectedCityIndex = null;
                        const categorySlug = this.bridgeService.slug() || 'experience'
                        this.router.navigate(['experience', categorySlug, country_slug, `page-${this.page}`])
                    }
                } else {
                    this.selectedCityIndex = null;
                }
            }
        });

        // for Gift-Ideas-Category-Component
        effect(() => {
            if (this.isGiftCategoryPage) {
                this.type = this.giftCategory.type();
                this.page = this.giftCategory.page();
                this.search_id = this.giftCategory.search_id();
                this.last_page = this.giftCategory.last_page();
                this.current_page = this.giftCategory.current_page();
                this.selected_location = this.giftCategory.selected_location();

                const currentslug = this.giftCategory.category_slug();
                if (this.highLevelCategoryList && this.highLevelCategoryList.length > 0) {
                    this.highLevelCategoryIndex = this.highLevelCategoryList.findIndex(
                        (cat: any) => cat.slug === currentslug
                    );
                } else {
                    this.highLevelCategoryIndex = null;
                }

                const countriesList = this.state.userData() || [];
                if (countriesList.length === 0) {
                    return;
                }

                const country_slug = this.giftCategory.country_slug();
                this.selectedCountryIndex = countriesList.findIndex(
                    (country: any) => country.slug === country_slug
                );

                if (country_slug && this.selectedCountryIndex === -1) {
                    if (this.isContentPreviewMode()) {
                        return;
                    }
                    this.routeNotFound.emit()
                    return;
                }

                let selected = countriesList[this.selectedCountryIndex];
                this.countrySelected = selected;

                if (selected?.slug === "united-states") {
                    const divisions = selected.child_locations || [];
                    let merged = divisions.flatMap((d: any) => d.division_data || []);
                    merged = merged.sort((a: any, b: any) => a.name.localeCompare(b.name));
                    this.selectedChlidLocations = merged;
                } else {
                    this.selectedChlidLocations = selected?.child_locations || [];
                }

                const currentCitySlug = this.giftCategory.state();
                if (currentCitySlug) {
                    if (this.selectedChlidLocations && this.selectedChlidLocations.length > 0) {
                        this.selectedCityIndex = this.selectedChlidLocations.findIndex(
                            (place: any) => place.slug === currentCitySlug
                        );

                        if (this.selectedCityIndex === -1) {
                            if (this.isContentPreviewMode()) {
                                this.selectedCityIndex = null;
                                return;
                            }
                            // const catrgorySlug = this.giftCategory.slug() || 'gifts';
                            // this.router.navigate(['gifts',catrgorySlug,country_slug,`page-${this.page}`])
                            this.routeNotFound.emit();
                            return;
                        }
                    } else {
                        this.selectedCityIndex = null;
                        const categorySlug = this.giftCategory.slug() || 'gifts'
                        this.router.navigate(['/gifts', categorySlug, country_slug, `page-${this.page}`])
                    }
                } else {
                    this.selectedCityIndex = null;
                }
            }
        });

        // for Location-Region-Component
        effect(() => {
            if (this.isLocationRegionPage) {
                this.type = this.locationBridge.type();
                this.slug = this.locationBridge.slug();
                this.placeSlug = this.locationBridge.placeSlug();
                this.city = this.locationBridge.city();
                this.search_id = this.locationBridge.search_id();
                this.location = this.locationBridge.location();
                this.searchedItem = this.locationBridge.searchedItem();
                this.location_travel = this.locationBridge.location_travel();
                this.last_page = this.locationBridge.last_page();
                this.current_page = this.locationBridge.current_page();
                this.page = this.locationBridge.page();

                // const currentId = this.locationBridge.category_id();
                // if (this.highLevelCategoryList && this.highLevelCategoryList.length > 0) {
                //     this.highLevelCategoryIndex = this.highLevelCategoryList.findIndex(
                //         (cat: any) => cat.id === currentId
                //     );
                // } else {
                //     this.highLevelCategoryIndex = null;
                // }

                const countriesList = this.state.userData() || [];
                if (countriesList.length === 0) {
                    return;
                }

                this.selectedCountryIndex = countriesList.findIndex(
                    (country: any) => country.slug === this.slug
                );

                this.countrySelected = countriesList[this.selectedCountryIndex];

                let selected = countriesList[this.selectedCountryIndex];
                let divisions: any[] = [];
                if (selected?.slug === "united-states") {
                    divisions = selected.child_locations || [];
                    let merged = divisions.flatMap((d: any) => d.division_data || []);
                    merged = merged.sort((a: any, b: any) => a.name.localeCompare(b.name));
                    this.selectedChlidLocations = merged;
                } else {
                    this.selectedChlidLocations = selected?.child_locations || [];
                }

                const currentCitySlug = this.placeSlug;
                if (currentCitySlug != '') {
                    if (this.selectedChlidLocations && this.selectedChlidLocations.length > 0) {
                        this.selectedCityIndex = this.selectedChlidLocations.findIndex(
                            (place: any) => place.slug === currentCitySlug
                        );

                        if (this.selectedCityIndex === -1) {
                            const isValidDivision = divisions.some(
                                (d: any) => d.division_name === currentCitySlug || d.division_name?.toLowerCase() === currentCitySlug.toLowerCase()
                            );
                            if (isValidDivision) {
                                this.selectedCityIndex = null;
                                this.city
                            } else {
                                this.routeNotFound.emit();
                                return;
                            }

                        } else {
                            this.citySelected = this.selectedChlidLocations[this.selectedCityIndex];
                        }
                    } else {
                        this.selectedCityIndex = null;
                    }
                }
            }
        });

        // for Location-Region-Category-New-Component
        effect(() => {
            if (this.isLocationRegionCategoryPage) {
                this.page = this.locationCatBdridge.page();
                this.type = this.locationCatBdridge.type();
                this.search_id = this.locationCatBdridge.search_id()
                this.searchedItem = this.locationCatBdridge.searchedItem();
                this.current_page = this.locationCatBdridge.current_page();
                this.categorySlug = this.locationCatBdridge.categorySlug();

                const countriesList = this.state.userData() || [];
                if (countriesList.length === 0) {
                    return;
                }

                let currentCountrySlug = this.locationCatBdridge.country();
                this.selectedCountryIndex = countriesList.findIndex(
                    (country: any) => country.slug === currentCountrySlug
                );

                this.countrySelected = countriesList[this.selectedCountryIndex];
                let selected = countriesList[this.selectedCountryIndex];
                let divisions: any[] = [];
                if (selected?.slug === "united-states") {
                    divisions = selected.child_locations || [];
                    let merged = divisions.flatMap((d: any) => d.division_data || []);
                    merged = merged.sort((a: any, b: any) => a.name.localeCompare(b.name));
                    this.selectedChlidLocations = merged;
                } else {
                    this.selectedChlidLocations = selected?.child_locations || [];
                }

                const currentCitySlug = this.locationCatBdridge.state();
                if (currentCitySlug != '') {
                    if (this.selectedChlidLocations && this.selectedChlidLocations.length > 0) {
                        this.selectedCityIndex = this.selectedChlidLocations.findIndex(
                            (place: any) => place.slug === currentCitySlug
                        );

                        if (this.selectedCityIndex === -1) {
                            const isValidDivision = divisions.some(
                                (d: any) => d.division_name === currentCitySlug || d.division_name?.toLowerCase() === currentCitySlug.toLowerCase()
                            );
                            if (isValidDivision) {
                                this.selectedCityIndex = null;
                                this.city
                            } else {
                                this.routeNotFound.emit();
                                return;
                            }
                        } else {
                            this.citySelected = this.selectedChlidLocations[this.selectedCityIndex];
                        }
                    } else {
                        this.selectedCityIndex = null;
                    }
                }
            }
        });

        effect(() => {
            if (this.isLocationRegionCategoryPage) {
                const currentId = this.locationCatBdridge.category_id();
                if (this.highLevelCategoryList && this.highLevelCategoryList.length > 0) {
                    this.highLevelCategoryIndex = this.highLevelCategoryList.findIndex(
                        (cat: any) => cat.id === currentId
                    );
                } else {
                    this.highLevelCategoryIndex = null;
                }
            }
        });

        this.modelChanged2.pipe(debounceTime(100)).subscribe(query => {
            if (query.trim().length >= 1) {
                this.onFilteringAfterDebounce(query);
            }
        });
    }

    sorting_by(order_by: string, order: string) {
        this.order_by = order_by;
        this.order = order;
        this.order_byChange.emit(order_by);
        this.orderChange.emit(order);
        this.prepareMapForFilterRefresh();
        this.pageChangeFromChild.emit(1);
    }

    getSortLabel(): string {
        if (this.order_by === 'price' && this.order === 'ASC') {
            return 'Price Low to High';
        } else if (this.order_by === 'price' && this.order === 'DESC') {
            return 'Price High to Low';
        } else if (this.order_by === 'vebo_fav') {
            return 'SPUR Favorites';
        }
        return 'Sort By';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['badge_id'] && !changes['badge_id'].firstChange && this.badgesLoaded) {
            this.syncBadgeSelectionFromId();
        }

        if (changes['view_on_map'] && !changes['view_on_map'].firstChange) {
            if (!this.view_on_map) {
                this.clearMapSearchState();
                this.highlightedMapIndex = null;
                this.hoveredMapIndex = null;
                this.setMapViewBodyClass(false);
            } else {
                this.setMapViewBodyClass(true);
            }
        }
        if (changes['start_date'] || changes['end_date'] || changes['is_booking']) {
            this.syncSelectedDateFromInputs();
        }
        // When map data finishes loading, normalize Spur pins and (unless this load was
        // from pan/zoom search or map pagination) fit the camera to the new listing.
        if (this.view_on_map && changes['isDataLoading'] && changes['isDataLoading'].previousValue === true
            && changes['isDataLoading'].currentValue === false) {
            // Defer so parent has finished writing the new experience list first
            setTimeout(() => {
                this.resetMapPinStyles();
                this.closeMapPinPopover();
                if (this.search_with_map) {
                    this.userMapGesture = false;
                    this.mapProgrammaticMove = false;
                    this.ignoreZoomSearchUntil = 0;
                    this.attachMapMoveSearchListener();
                }
            }, 0);
            const skipFit = this.skipFitOnNextMapLoad;
            this.skipFitOnNextMapLoad = false;
            if (!skipFit) {
                this.mapFitLocked = false;
                this.suppressNextMapIdleSearch = true;
                this.scheduleFitMapToMarkers([120, 380]);
                setTimeout(() => this.syncBoundsKeyAfterFilterFit(), 550);
            }
            setTimeout(() => this.updateMapStickyPosition(), 50);
            setTimeout(() => this.updateMapStickyPosition(), 400);
        }
    }

    syncSelectedDateFromInputs() {
        this.suppressDateEmit = true;
        const validStart = this.parseLocalDate(this.start_date);
        const validEnd = this.parseLocalDate(this.end_date);

        if (this.useDateRangePicker) {
            this.selectedDateRange = (validStart && validEnd) ? [validStart, validEnd] : [];
            this.selectedDate = null;
        } else {
            this.selectedDate = validStart;
            this.selectedDateRange = [];
        }

        setTimeout(() => {
            this.suppressDateEmit = false;
        });
    }

    /** Parse yyyy-MM-dd as local calendar date (avoids UTC off-by-one). */
    parseLocalDate(value: any): Date | null {
        if (!value) {
            return null;
        }
        if (value instanceof Date) {
            return isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }
        const str = String(value).trim();
        const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(str);
        if (match) {
            const year = Number(match[1]);
            const month = Number(match[2]) - 1;
            const day = Number(match[3]);
            const local = new Date(year, month, day);
            return isNaN(local.getTime()) ? null : local;
        }
        const fallback = new Date(str);
        if (isNaN(fallback.getTime())) {
            return null;
        }
        return new Date(fallback.getFullYear(), fallback.getMonth(), fallback.getDate());
    }

    /** Format Date using local Y/M/D (avoids UTC off-by-one). */
    formatLocalDate(value: Date | null | undefined): string {
        if (!value || isNaN(value.getTime())) {
            return '';
        }
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    onShowPicker(_event: any) {
        // no-op: avoid auto day-select handlers that re-trigger value changes
    }

    get useDateRangePicker(): boolean {
        return !!(this.isLocationRegionPage || this.isLocationRegionCategoryPage);
    }

    onSchedulingDateSelect(event: Date | null) {
        if (this.suppressDateEmit) {
            return;
        }

        if (!event) {
            if (!this.start_date && !this.end_date) {
                return;
            }
            this.clearDate();
            return;
        }

        const formatted = this.formatLocalDate(event);
        if (!formatted || (formatted === this.start_date && formatted === this.end_date)) {
            return;
        }

        this.selectedDate = this.parseLocalDate(formatted);
        this.start_date = formatted;
        this.end_date = formatted;
        this.dateRangeChange.emit({ start_date: this.start_date, end_date: this.end_date });
    }

    onSchedulingDateRangeSelect(event: Date[] | null) {
        if (this.suppressDateEmit) {
            return;
        }

        // Ignore partial/null updates while the user is still picking the range.
        if (!event || !Array.isArray(event) || event.length !== 2 || !event[0] || !event[1]) {
            return;
        }

        const start = this.formatLocalDate(event[0]);
        const end = this.formatLocalDate(event[1]);
        if (!start || !end || (start === this.start_date && end === this.end_date)) {
            return;
        }

        this.selectedDateRange = [
            this.parseLocalDate(start) as Date,
            this.parseLocalDate(end) as Date
        ];
        this.start_date = start;
        this.end_date = end;
        this.dateRangeChange.emit({ start_date: this.start_date, end_date: this.end_date });
    }

    clearDate() {
        if (this.suppressDateEmit) {
            return;
        }
        if (!this.start_date && !this.end_date && !this.selectedDate && !this.selectedDateRange?.length) {
            return;
        }
        this.suppressDateEmit = true;
        this.selectedDate = null;
        this.selectedDateRange = [];
        this.start_date = '';
        this.end_date = '';
        this.dateCustomClasses = [];
        this.dateRangeChange.emit({ start_date: '', end_date: '' });
        setTimeout(() => {
            this.suppressDateEmit = false;
        });
    }

    get showMapToggle(): boolean {
        return (this.isLocationRegionPage || this.isLocationRegionCategoryPage)
            && this.enable_rfp_225
            && this.is_booking !== 2;
    }

    get effectiveMapCenter(): { lat: number; lng: number } {
        if (this.mapCenter?.lat != null && this.mapCenter?.lng != null
            && this.mapCenter.lat !== '' && this.mapCenter.lng !== '') {
            return { lat: +this.mapCenter.lat, lng: +this.mapCenter.lng };
        }
        const data = this.experienceData();
        if (data?.length && data[0]?.latitude != null && data[0]?.longitude != null) {
            return { lat: +data[0].latitude, lng: +data[0].longitude };
        }
        return { lat: 39.8283, lng: -98.5795 };
    }

    /** Snapshot center once when opening map view (avoids jump on later data refreshes). */
    private syncMapViewCenterFromInputs() {
        const c = this.effectiveMapCenter;
        if (!isNaN(c.lat) && !isNaN(c.lng) && (c.lat !== 0 || c.lng !== 0)) {
            this.mapViewCenter = { lat: c.lat, lng: c.lng };
        }
    }

    map_view(mapview: any) {
        this.view_on_map = mapview?.target?.checked;
        this.view_on_mapChange.emit(this.view_on_map);
        this.closeActiveInfoWindow();
        this.highlightedMapIndex = null;
        this.hoveredMapIndex = null;
        this.page = 1;

        // Do not clear the list here — that caused a flash of "No experiences found".
        // Parent refetch will replace data; map column shows a loader while isDataLoading.

        if (this.isBrowser && this.view_on_map) {
            this.setMapViewBodyClass(true);
            this.syncMapViewCenterFromInputs();
            // Default ON: Search as I move the map (listener attached in onMapInitialized)
            this.search_with_map = true;
            this.mapFitLocked = false;
            this.lastSearchedBoundsKey = '';
            this.skipFitOnNextMapLoad = false;
            this.scheduleFitMapToMarkers();
        } else {
            this.setMapViewBodyClass(false);
            this.clearMapSearchState();
            this.resetMapPinStyles();
        }
        this.pageChangeFromChild.emit(1);
    }

    /** Keep mapfixed off so legacy global map sticky rules do not fight map sticky. */
    private setMapViewBodyClass(active: boolean) {
        if (!this.isBrowser || typeof document === 'undefined') {
            return;
        }
        document.body.classList.toggle('spur-map-view-active', active);
        document.body.classList.remove('mapfixed');
        this.syncFilterPinPageClass();
        if (active) {
            this.bindMapStickyListeners();
            // Layout may not exist until next tick after *ngIf
            setTimeout(() => this.updateMapStickyPosition(), 0);
            setTimeout(() => this.updateMapStickyPosition(), 100);
        } else {
            this.unbindMapStickyListeners();
            this.clearMapStickyPosition();
        }
    }

    /** Desktop listing only. Lets the filter column use position:sticky without touching map view. */
    private syncFilterPinPageClass(): void {
        if (!this.isBrowser || typeof document === 'undefined') {
            return;
        }
        const enable = !this.isTabletOrBelow && !this.view_on_map;
        document.body.classList.toggle('exp-filter-pin-page', enable);
    }

    private bindMapStickyListeners() {
        if (!this.isBrowser || this.mapStickyListening) {
            return;
        }
        this.mapStickyListening = true;
        this.ngZone.runOutsideAngular(() => {
            window.addEventListener('scroll', this.onMapStickyScroll, { passive: true });
            window.addEventListener('resize', this.onMapStickyScroll, { passive: true });
        });
    }

    private unbindMapStickyListeners() {
        if (!this.isBrowser || !this.mapStickyListening) {
            return;
        }
        this.mapStickyListening = false;
        window.removeEventListener('scroll', this.onMapStickyScroll);
        window.removeEventListener('resize', this.onMapStickyScroll);
        if (this.mapStickyRaf) {
            cancelAnimationFrame(this.mapStickyRaf);
            this.mapStickyRaf = 0;
        }
    }

    private scheduleMapStickyUpdate() {
        if (!this.isBrowser || this.mapStickyRaf) {
            return;
        }
        this.mapStickyRaf = requestAnimationFrame(() => {
            this.mapStickyRaf = 0;
            this.updateMapStickyPosition();
        });
    }

    /**
     * Pin the map under the header while the list scrolls, release at the top of the
     * column (no float above section), and clamp to the column bottom.
     * Width/height are locked in px so the map box never resizes on stick/unstick.
     */
    private updateMapStickyPosition() {
        if (!this.isBrowser || !this.view_on_map || this.isTabletOrBelow) {
            this.clearMapStickyPosition();
            return;
        }
        const col = this.mapStickyCol?.nativeElement;
        const map = this.stickyMapEl?.nativeElement;
        const canvas = this.mapCanvasWrap?.nativeElement;
        if (!col || !map) {
            return;
        }

        const topGap = this.mapStickyTopGap;
        const colRect = col.getBoundingClientRect();

        // Capture natural size while still in-flow (before fixed removes it from layout)
        if (this.mapStickyState === 'static') {
            const w = Math.round(map.getBoundingClientRect().width || map.offsetWidth || col.offsetWidth);
            const h = Math.round(map.getBoundingClientRect().height || map.offsetHeight);
            if (w > 0) {
                this.mapStickyLockW = w;
            }
            if (h > 0) {
                this.mapStickyLockH = h;
            }
            if (canvas) {
                const ch = Math.round(canvas.getBoundingClientRect().height || canvas.offsetHeight);
                if (ch > 0) {
                    this.mapStickyLockCanvasH = ch;
                }
            }
        }

        const mapHeight = this.mapStickyLockH || map.offsetHeight || 0;
        if (mapHeight <= 0 || this.mapStickyLockW <= 0) {
            return;
        }

        let next: 'static' | 'fixed' | 'bottom' = 'static';
        if (colRect.top >= topGap) {
            next = 'static';
        } else if (colRect.bottom <= topGap + mapHeight) {
            next = 'bottom';
        } else {
            next = 'fixed';
        }

        const prev = this.mapStickyState;
        const nextSpacer = next === 'static' ? 0 : mapHeight;

        // On window resize while stuck, refresh locked width from the column only
        if (next !== 'static' && prev !== 'static') {
            const colW = Math.round(col.offsetWidth);
            if (colW > 0 && Math.abs(colW - this.mapStickyLockW) > 1) {
                this.mapStickyLockW = colW;
            }
        }

        if (next === 'fixed') {
            map.style.position = '';
            map.style.left = `${Math.round(colRect.left)}px`;
            map.style.width = `${this.mapStickyLockW}px`;
            map.style.height = `${this.mapStickyLockH}px`;
            map.style.maxWidth = 'none';
            map.style.maxHeight = 'none';
            map.style.top = '';
            map.style.bottom = '';
            if (canvas && this.mapStickyLockCanvasH > 0) {
                canvas.style.height = `${this.mapStickyLockCanvasH}px`;
                canvas.style.minHeight = `${this.mapStickyLockCanvasH}px`;
                canvas.style.maxHeight = 'none';
            }
        } else if (next === 'bottom') {
            map.style.position = '';
            map.style.left = '0';
            map.style.width = `${this.mapStickyLockW}px`;
            map.style.height = `${this.mapStickyLockH}px`;
            map.style.maxWidth = 'none';
            map.style.maxHeight = 'none';
            map.style.top = '';
            map.style.bottom = '';
            if (canvas && this.mapStickyLockCanvasH > 0) {
                canvas.style.height = `${this.mapStickyLockCanvasH}px`;
                canvas.style.minHeight = `${this.mapStickyLockCanvasH}px`;
                canvas.style.maxHeight = 'none';
            }
        } else {
            this.clearMapStickyInlineSize(map, canvas);
        }

        if (prev !== next || this.mapStickySpacerPx !== nextSpacer) {
            this.mapStickyState = next;
            this.mapStickySpacerPx = nextSpacer;
            this.ngZone.run(() => this.cdref.detectChanges());
            // Do NOT refreshMapSize / move camera on sticky toggle — list scroll must not
            // change map lat/long. Only re-sync tiles if locked width changed on resize.
        }
    }

    private clearMapStickyInlineSize(map?: HTMLElement | null, canvas?: HTMLElement | null) {
        const mapEl = map ?? this.stickyMapEl?.nativeElement;
        const canvasEl = canvas ?? this.mapCanvasWrap?.nativeElement;
        if (mapEl) {
            mapEl.style.left = '';
            mapEl.style.width = '';
            mapEl.style.height = '';
            mapEl.style.maxWidth = '';
            mapEl.style.maxHeight = '';
            mapEl.style.top = '';
            mapEl.style.bottom = '';
            mapEl.style.position = '';
        }
        if (canvasEl) {
            canvasEl.style.height = '';
            canvasEl.style.minHeight = '';
            canvasEl.style.maxHeight = '';
        }
    }

    private clearMapStickyPosition() {
        this.clearMapStickyInlineSize();
        this.mapStickyLockW = 0;
        this.mapStickyLockH = 0;
        this.mapStickyLockCanvasH = 0;
        const changed = this.mapStickyState !== 'static' || this.mapStickySpacerPx !== 0;
        this.mapStickyState = 'static';
        this.mapStickySpacerPx = 0;
        if (changed) {
            this.ngZone.run(() => this.cdref.detectChanges());
        }
    }

    /** After Google Map mounts, size it to the wrap then fit pins. */
    onMapInitialized() {
        this.mapFitLocked = false;
        if (this.googleMap?.googleMap) {
            this.googleMap.googleMap.setOptions({
                ...this.mapOptions,
                scrollwheel: false,
                gestureHandling: 'cooperative',
            });
        }
        this.refreshMapSize();
        this.scheduleFitMapToMarkers([80, 320]);
        this.setupMapResizeGuard();
        // Default ON — same pattern as add-user-experience (attach after map is ready)
        this.search_with_map = true;
        setTimeout(() => this.searchWithMap(true), 400);
        setTimeout(() => {
            if (this.search_with_map) {
                this.searchWithMap(true);
            }
        }, 1000);
    }

    private clearMapFitTimers() {
        this.mapFitTimers.forEach((t) => clearTimeout(t));
        this.mapFitTimers = [];
    }

    private scheduleFitMapToMarkers(delays: number[] = [150, 400]) {
        this.clearMapFitTimers();
        delays.forEach((ms) => {
            this.mapFitTimers.push(setTimeout(() => {
                if (this.mapFitLocked) {
                    return;
                }
                this.refreshMapSize();
                this.fitMapToMarkers();
            }, ms));
        });
    }

    /** Lock auto-fit so pin/list clicks never reset zoom back to "show all". */
    private lockMapAutoFit() {
        this.mapFitLocked = true;
        this.mapFitGeneration++;
        this.clearMapFitTimers();
    }

    /**
     * Tell Maps API the div size changed so tiles fill the container.
     * Always restore center/zoom — bare resize often jumps to a world view.
     * Mark as programmatic so sticky/list scroll never triggers lat_long search.
     */
    private refreshMapSize() {
        if (!this.isBrowser || !this.googleMap?.googleMap) {
            return;
        }
        const map = this.googleMap.googleMap;
        const center = map.getCenter() || (
            this.lastStableCamera
                ? new google.maps.LatLng(this.lastStableCamera.lat, this.lastStableCamera.lng)
                : null
        );
        const zoom = map.getZoom() ?? this.lastStableCamera?.zoom;
        const mapEl = map.getDiv?.() || null;
        this.mapProgrammaticMove = true;
        // Only suppress zoom_changed from this resize — dragend stays live for search-as-I-move
        this.ignoreZoomSearchUntil = Date.now() + 400;
        this.suppressNextMapIdleSearch = true;
        google.maps.event.trigger(map, 'resize');
        if (mapEl) {
            mapEl.style.width = '100%';
            mapEl.style.height = '100%';
        }
        if (center) {
            map.setCenter(center);
        }
        if (zoom != null) {
            map.setZoom(zoom);
        }
        this.captureStableCamera();
        setTimeout(() => {
            this.mapProgrammaticMove = false;
            this.suppressNextMapIdleSearch = false;
        }, 400);
    }

    private captureStableCamera() {
        if (!this.googleMap?.googleMap) {
            return;
        }
        const map = this.googleMap.googleMap;
        const c = map.getCenter();
        const z = map.getZoom();
        if (!c || z == null) {
            return;
        }
        this.lastStableCamera = { lat: c.lat(), lng: c.lng(), zoom: z };
    }

    /**
     * Keep map size in sync if the canvas wrap resizes (window resize / sticky affix).
     */
    private setupMapResizeGuard() {
        if (!this.isBrowser || typeof ResizeObserver === 'undefined') {
            return;
        }
        this.teardownMapResizeGuard();
        const wrap = this.mapCanvasWrap?.nativeElement;
        if (!wrap) {
            return;
        }
        this.mapResizeObserver = new ResizeObserver(() => {
            if (!this.view_on_map || !this.googleMap?.googleMap) {
                return;
            }
            // Debounce sticky affix size flips — never treat as user map pan/zoom
            if (this.mapResizeGuardTimer) {
                clearTimeout(this.mapResizeGuardTimer);
            }
            // Only block programmatic zoom restore — never block user dragend searches
            this.mapProgrammaticMove = true;
            this.suppressNextMapIdleSearch = true;
            this.mapResizeGuardTimer = setTimeout(() => {
                this.mapResizeGuardTimer = null;
                this.refreshMapSize();
                setTimeout(() => {
                    this.mapProgrammaticMove = false;
                    this.suppressNextMapIdleSearch = false;
                }, 200);
            }, 80);
        });
        this.mapResizeObserver.observe(wrap);
    }

    private teardownMapResizeGuard() {
        if (this.mapResizeObserver) {
            this.mapResizeObserver.disconnect();
            this.mapResizeObserver = null;
        }
        if (this.mapResizeGuardTimer) {
            clearTimeout(this.mapResizeGuardTimer);
            this.mapResizeGuardTimer = null;
        }
    }

    /** Fit every marker into the map with padding so pins stay clearly visible. */
    fitMapToMarkers() {
        if (!this.isBrowser || !this.view_on_map || !this.googleMap?.googleMap) {
            return;
        }
        if (this.mapFitLocked) {
            return;
        }
        const data = this.experienceData();
        if (!data?.length) {
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        let count = 0;
        for (const record of data) {
            const lat = +record?.latitude;
            const lng = +record?.longitude;
            if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                bounds.extend({ lat, lng });
                count++;
            }
        }
        if (!count) {
            return;
        }

        const map = this.googleMap.googleMap;
        const generation = ++this.mapFitGeneration;
        this.mapProgrammaticMove = true;
        this.suppressNextMapIdleSearch = true;
        map.fitBounds(bounds, { top: 48, right: 48, bottom: 48, left: 48 });
        google.maps.event.addListenerOnce(map, 'idle', () => {
            // Ignore stale fits if user already focused a pin or a newer fit started
            if (this.mapFitLocked || generation !== this.mapFitGeneration) {
                this.mapProgrammaticMove = false;
                return;
            }
            const zoom = map.getZoom();
            if (zoom == null) {
                this.mapProgrammaticMove = false;
                return;
            }
            if (count === 1) {
                map.setZoom(Math.min(zoom, 13));
            } else if (zoom > 14) {
                map.setZoom(14);
            }
            this.captureStableCamera();
            this.mapProgrammaticMove = false;
            // Do not force-zoom-in on wide country bounds — that fought user/category views
        });
    }

    /**
     * Marker icon for the template.
     * Red teardrop SVG + circular experience photo layered on top.
     * Never returns API map_image_url (those include the circular tip ring).
     */
    markerIconFor(record: any, index: number) {
        const state: 'default' | 'highlight' =
            this.highlightedMapIndex === index || this.hoveredMapIndex === index
                ? 'highlight'
                : 'default';
        return this.buildMapPinIcon(state, record);
    }

    /**
     * Experience listing photo, or vebolife_img.jpg when missing/null/empty.
     * Never uses map_image_url (pre-baked pins with the circular ring).
     */
    private resolveMapPinPhotoUrl(record?: any): string {
        const raw = record?.image_url;
        if (raw == null) {
            return this.defaultMapPinPhoto;
        }
        const listing = String(raw).trim();
        if (!listing || listing === 'null' || listing === 'undefined' || listing === 'None') {
            return this.defaultMapPinPhoto;
        }
        return listing;
    }

    private mapPinCacheKey(photoUrl: string, state: string): string {
        return `${photoUrl}|${state}|${this.mapPinCacheVersion}`;
    }

    private mapPinSize(state: 'default' | 'highlight' | 'dimmed') {
        // Preserve 51×70 SVG aspect ratio; highlight is clearly larger on hover/focus
        if (state === 'highlight') {
            return { width: 60, height: 82 };
        }
        if (state === 'dimmed') {
            return { width: 32, height: 44 };
        }
        return { width: 44, height: 60 };
    }

    private toMapsIcon(
        url: string,
        size: { width: number; height: number }
    ): google.maps.Icon {
        if (typeof google !== 'undefined' && google?.maps?.Size && google?.maps?.Point) {
            return {
                url,
                scaledSize: new google.maps.Size(size.width, size.height),
                anchor: new google.maps.Point(size.width / 2, size.height),
            };
        }
        return {
            url,
            scaledSize: size as any,
            anchor: { x: size.width / 2, y: size.height } as any,
        };
    }

    private pinFillColor(state: 'default' | 'highlight' | 'dimmed'): string {
        return state === 'dimmed' ? '#C4B8B3' : '#F22C2C';
    }

    /** Immediate placeholder: provided pin SVG only — no rings, no photo yet. */
    private buildPlaceholderPinSvg(state: 'default' | 'highlight' | 'dimmed'): string {
        const pinColor = this.pinFillColor(state);
        const svg =
            `<svg xmlns="http://www.w3.org/2000/svg" width="${this.mapPinViewW}" height="${this.mapPinViewH}" viewBox="0 0 ${this.mapPinViewW} ${this.mapPinViewH}" fill="none">` +
            `<path d="${this.mapPinPathD}" fill="${pinColor}"/>` +
            `</svg>`;
        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    }

    private buildMapPinIcon(
        state: 'default' | 'highlight' | 'dimmed' = 'default',
        record?: any
    ) {
        const size = this.mapPinSize(state);
        const photoUrl = this.resolveMapPinPhotoUrl(record);
        const cacheKey = this.mapPinCacheKey(photoUrl, state);

        const cached = this.mapPinIconCache.get(cacheKey);
        if (cached) {
            if (record) {
                record.map_image = cached;
            }
            return cached;
        }

        // Never leave API pin graphics on the record (circular tip ring)
        const apiPin = record?.map_image_url != null ? String(record.map_image_url).trim() : '';
        const currentUrl = record?.map_image?.url ? String(record.map_image.url) : '';
        const isOurIcon =
            currentUrl.startsWith('data:image/png') ||
            currentUrl.startsWith('data:image/svg');

        const placeholder = this.toMapsIcon(this.buildPlaceholderPinSvg(state), size);
        if (record && (!isOurIcon || (apiPin && currentUrl === apiPin))) {
            record.map_image = placeholder;
        }

        if (!this.isBrowser) {
            this.mapPinIconCache.set(cacheKey, placeholder);
            return placeholder;
        }

        this.composeAndApplyPhotoPin(photoUrl, state, record ?? null);
        if (state === 'default') {
            this.composeAndApplyPhotoPin(photoUrl, 'highlight', null);
        }

        return record?.map_image?.url?.startsWith?.('data:')
            ? record.map_image
            : placeholder;
    }

    private readonly mapPinComposeInflight = new Map<string, Promise<string | null>>();

    private composeAndApplyPhotoPin(
        photoUrl: string,
        state: 'default' | 'highlight' | 'dimmed',
        record: any | null
    ) {
        const size = this.mapPinSize(state);
        const cacheKey = this.mapPinCacheKey(photoUrl, state);
        if (this.mapPinIconCache.has(cacheKey)) {
            if (record) {
                this.applyCachedPinToRecord(record, photoUrl);
            }
            return;
        }
        this.composePhotoMapPin(photoUrl, state, cacheKey).then((dataUrl) => {
            const icon = this.toMapsIcon(
                dataUrl || this.buildPlaceholderPinSvg(state),
                size
            );
            this.mapPinIconCache.set(cacheKey, icon);
            if (record && this.resolveMapPinPhotoUrl(record) === photoUrl) {
                this.applyCachedPinToRecord(record, photoUrl);
                this.ngZone.run(() => this.cdref.detectChanges());
            }
        });
    }

    private applyCachedPinToRecord(record: any, photoUrl: string) {
        const data = this.experienceData();
        const index = data?.indexOf?.(record) ?? -1;
        const applyState: 'default' | 'highlight' =
            index >= 0 &&
                (this.highlightedMapIndex === index || this.hoveredMapIndex === index)
                ? 'highlight'
                : 'default';
        const cached = this.mapPinIconCache.get(this.mapPinCacheKey(photoUrl, applyState));
        if (cached) {
            record.map_image = cached;
        }
    }

    private loadPinPhoto(url: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('pin photo load failed'));
            img.src = url;
        });
    }

    /**
     * Compose marker: user SVG pin path as base, circular experience photo on top.
     * No tip ellipse / ground ring / white halo circles.
     */
    private composePhotoMapPin(
        photoUrl: string,
        state: 'default' | 'highlight' | 'dimmed',
        cacheKey: string
    ): Promise<string | null> {
        if (this.mapPinComposeInflight.has(cacheKey)) {
            return this.mapPinComposeInflight.get(cacheKey)!;
        }
        const promise = (async () => {
            const pinColor = this.pinFillColor(state);
            const scale = 2; // retina
            const vbW = this.mapPinViewW;
            const vbH = this.mapPinViewH;
            const canvas = document.createElement('canvas');
            canvas.width = vbW * scale;
            canvas.height = vbH * scale;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return null;
            }
            ctx.scale(scale, scale);

            // Layer 1: provided red teardrop SVG path (no rings)
            const teardrop = new Path2D(this.mapPinPathD);
            ctx.fillStyle = pinColor;
            ctx.fill(teardrop);

            // Layer 2: circular experience image on top of the pin bulb
            let photo: HTMLImageElement | null = null;
            try {
                photo = await this.loadPinPhoto(photoUrl);
            } catch {
                if (photoUrl !== this.defaultMapPinPhoto) {
                    try {
                        photo = await this.loadPinPhoto(this.defaultMapPinPhoto);
                    } catch {
                        photo = null;
                    }
                }
            }

            const cx = this.mapPinPhotoCx;
            const cy = this.mapPinPhotoCy;
            const r = this.mapPinPhotoR;

            ctx.save();
            ctx.beginPath();
            ctx.arc(cx, cy, r, 0, Math.PI * 2);
            ctx.closePath();
            ctx.clip();

            if (photo) {
                const dia = r * 2;
                const dx = cx - r;
                const dy = cy - r;
                const iw = photo.naturalWidth || photo.width;
                const ih = photo.naturalHeight || photo.height;
                const cover = Math.max(dia / iw, dia / ih);
                const dw = iw * cover;
                const dh = ih * cover;
                ctx.drawImage(photo, dx + (dia - dw) / 2, dy + (dia - dh) / 2, dw, dh);
            } else {
                ctx.fillStyle = '#FFF5F0';
                ctx.fillRect(cx - r, cy - r, r * 2, r * 2);
            }
            ctx.restore();

            return canvas.toDataURL('image/png');
        })()
            .catch(() => null)
            .finally(() => {
                this.mapPinComposeInflight.delete(cacheKey);
            });

        this.mapPinComposeInflight.set(cacheKey, promise);
        return promise;
    }

    trackByExperienceId(index: number, record: any) {
        return record?.id ?? index;
    }

    /**
     * Highlight a pin. Does not dim the listing (avoids overlay look).
     * Pan only when explicitly requested (map pin / location button) — never on list scroll/hover.
     */
    focusMapPin(index: number, event?: Event, opts?: { pan?: boolean }) {
        event?.preventDefault();
        event?.stopPropagation();
        const data = this.experienceData();
        if (!data?.[index]) {
            return;
        }

        this.lockMapAutoFit();

        this.hoveredMapIndex = null;
        this.highlightedMapIndex = index;
        data.forEach((record, i) => {
            if (i === index) {
                record.map_image = this.buildMapPinIcon('highlight', record);
                record.zindex = 999;
                record.map_dimmed = false;
            } else {
                // Keep other pins visible at default size — do not dim the list cards
                record.map_image = this.buildMapPinIcon('default', record);
                record.zindex = 1;
                record.map_dimmed = false;
            }
        });

        if (opts?.pan === false) {
            return;
        }
        const lat = +data[index].latitude;
        const lng = +data[index].longitude;
        if (this.googleMap?.googleMap && !isNaN(lat) && !isNaN(lng)) {
            this.mapProgrammaticMove = true;
            this.ignoreZoomSearchUntil = Date.now() + 400;
            this.googleMap.googleMap.panTo({ lat, lng });
            setTimeout(() => {
                this.mapProgrammaticMove = false;
                this.captureStableCamera();
            }, 350);
        }
    }

    resetMapPinStyles() {
        const data = this.experienceData();
        if (!data?.length) {
            return;
        }
        this.highlightedMapIndex = null;
        this.hoveredMapIndex = null;
        data.forEach((record) => {
            // Strip API pin graphics (circular halo) then compose clean teardrop + photo
            record.map_image = null;
            record.map_image = this.buildMapPinIcon('default', record);
            record.zindex = 1;
            record.map_dimmed = false;
        });
        this.cdref.detectChanges();
    }

    clearMapSearchState() {
        this.search_with_map = false;
        this.lat_long = '';
        this.lat_longChange.emit('');
        this.lastSearchedBoundsKey = '';
        this.mapMoveListenerReady = false;
        this.clearMapSearchDebounce();
        this.detachMapMoveSearchListener();
        this.teardownMapResizeGuard();
        this.lastStableCamera = null;
    }

    /** Toggle from the always-visible checkbox */
    onSearchAsIMoveChange(event: Event) {
        const checked = !!(event?.target as HTMLInputElement)?.checked;
        this.searchWithMap(checked ? 1 : 0);
    }

    /**
     * Enable/disable search-as-I-move.
     * Matches the proven add-user-experience pattern: dragend/zoom → set lat_long → fetch.
     */
    searchWithMap(event: any) {
        this.search_with_map = !!event;
        this.fitbounds = false;
        if (!this.googleMap?.googleMap) {
            return;
        }
        if (this.search_with_map) {
            this.mapFitLocked = true;
            this.mapProgrammaticMove = false;
            this.ignoreZoomSearchUntil = 0;
            this.closeMapPinPopover();
            this.attachMapMoveSearchListener();
        } else {
            this.detachMapMoveSearchListener();
            this.clearMapSearchDebounce();
            this.closeMapPinPopover();
            this.lat_long = '';
            this.lastSearchedBoundsKey = '';
            this.lat_longChange.emit('');
        }
    }

    /**
     * Simple listeners (same as add-user-experience). No sticky/resize gates on dragend —
     * every user pan/zoom must call the API and reset the listing.
     */
    private attachMapMoveSearchListener() {
        if (!this.googleMap?.googleMap) {
            return;
        }
        this.detachMapMoveSearchListener();
        const map = this.googleMap.googleMap;

        this.mapDragEndEvent = map.addListener('dragend', () => {
            if (!this.search_with_map) {
                return;
            }
            // Every pan must hit the API — clear dedupe key
            this.lastSearchedBoundsKey = '';
            this.ngZone.run(() => this.triggerMapViewportSearch());
        });

        this.mapZoomListener = map.addListener('zoom_changed', () => {
            if (!this.search_with_map) {
                return;
            }
            if (this.mapProgrammaticMove || Date.now() < this.ignoreZoomSearchUntil) {
                return;
            }
            this.ngZone.run(() => {
                this.clearMapSearchDebounce();
                this.mapSearchDebounceTimer = setTimeout(() => {
                    this.mapSearchDebounceTimer = null;
                    this.lastSearchedBoundsKey = '';
                    this.triggerMapViewportSearch();
                }, 280);
            });
        });

        this.mapMoveListenerReady = true;
    }

    private detachMapMoveSearchListener() {
        if (this.mapDragEndEvent) {
            this.mapDragEndEvent.remove();
            this.mapDragEndEvent = null as any;
        }
        if (this.mapZoomListener) {
            this.mapZoomListener.remove();
            this.mapZoomListener = null;
        }
        if (this.mapDragStartListener) {
            this.mapDragStartListener.remove();
            this.mapDragStartListener = null;
        }
        if (this.mapIdleSearchListener) {
            this.mapIdleSearchListener.remove();
            this.mapIdleSearchListener = null;
        }
        this.mapMoveListenerReady = false;
    }

    private clearMapSearchDebounce() {
        if (this.mapSearchDebounceTimer) {
            clearTimeout(this.mapSearchDebounceTimer);
            this.mapSearchDebounceTimer = null;
        }
    }

    private boundsKey(json: google.maps.LatLngBoundsLiteral): string {
        const round = (n: number) => Math.round(n * 10000) / 10000;
        return `${round(json.south)},${round(json.west)},${round(json.north)},${round(json.east)}`;
    }

    /** Debounced bounds search (zoom only). */
    private queueMapBoundsSearch(delayMs = 320) {
        this.clearMapSearchDebounce();
        this.mapSearchDebounceTimer = setTimeout(() => {
            this.mapSearchDebounceTimer = null;
            this.triggerMapViewportSearch();
        }, delayMs);
    }

    /**
     * Instantly reset listing and call get-experience-by-location with the current
     * viewport bounds (and map center). Same contract as add-user-experience.
     */
    private triggerMapViewportSearch() {
        if (!this.search_with_map || !this.googleMap?.googleMap) {
            return;
        }
        const bounds = this.googleMap.getBounds();
        if (!bounds) {
            return;
        }
        const json = bounds.toJSON();
        if (
            json.north == null || json.south == null ||
            json.east == null || json.west == null ||
            isNaN(json.north) || isNaN(json.south) ||
            isNaN(json.east) || isNaN(json.west)
        ) {
            return;
        }
        const center = this.googleMap.getCenter?.() || this.googleMap.googleMap.getCenter();
        const key = this.boundsKey(json);
        this.lastSearchedBoundsKey = key;
        this.mapFitLocked = true;
        this.skipFitOnNextMapLoad = true;
        this.mapProgrammaticMove = false;
        this.captureStableCamera();

        // Viewport bounds for backend filter (same shape as add-user-experience)
        this.lat_long = {
            south: json.south,
            west: json.west,
            north: json.north,
            east: json.east,
        };
        if (center) {
            // Also expose map center for consumers that need it
            (this.lat_long as any).lat = center.lat();
            (this.lat_long as any).lng = center.lng();
        }
        this.page = 1;

        // Parent onMapLatLongChange sets lat_long and fetches immediately
        this.lat_longChange.emit(this.lat_long);
        this.experienceDataChange.emit([]);
    }

    /** @deprecated use triggerMapViewportSearch */
    private runMapBoundsSearch(_force = false) {
        this.triggerMapViewportSearch();
    }

    /**
     * Filters / category changes should load the full matching listing (not the previous
     * map viewport), then fit the map to those pins.
     */
    private prepareMapForFilterRefresh() {
        if (!this.view_on_map) {
            return;
        }
        this.skipFitOnNextMapLoad = false;
        this.mapFitLocked = false;
        this.lastSearchedBoundsKey = '';
        this.lat_long = '';
        this.lat_longChange.emit('');
    }

    /** Sync page=1 onto bridges so the next listing fetch is not stale. */
    private resetListingPageLocally(): void {
        this.page = 1;
        if (this.isLocationRegionPage) {
            this.locationBridge.setPage(1);
        }
        if (this.isLocationRegionCategoryPage) {
            this.locationCatBdridge.setPage(1);
        }
        if (this.isHighLevelCategoryPage) {
            this.bridgeService.setPage(1);
        }
        if (this.isGiftCategoryPage) {
            this.giftCategory.setPage(1);
        }
        if (this.isGiftIdeasPage) {
            this.giftideaBridge.setPage(1);
        }
    }

    /**
     * Listing refresh from filters — one parent fetch only.
     * Prefer this over pairing with pageChangeFromChild (that would double-call the API).
     */
    private requestListingRefresh(options?: { resetPage?: boolean }) {
        if (options?.resetPage) {
            this.resetListingPageLocally();
        }
        this.prepareMapForFilterRefresh();
        // Defer so parent bridge→page effects apply before the fetch runs.
        if (this.isBrowser && options?.resetPage) {
            setTimeout(() => this.getAllExperinceData.emit(), 0);
            return;
        }
        this.getAllExperinceData.emit();
    }

    /** After a filter-driven fitBounds, sync bounds key so the next user pan is detected. */
    private syncBoundsKeyAfterFilterFit() {
        if (!this.googleMap?.googleMap) {
            this.suppressNextMapIdleSearch = false;
            return;
        }
        const bounds = this.googleMap.getBounds();
        if (bounds) {
            const json = bounds.toJSON();
            this.lastSearchedBoundsKey = this.boundsKey(json);
            // Do NOT emit lat_longChange here — that would re-fetch. Only seed the dedupe key.
            if (this.search_with_map) {
                this.mapFitLocked = true;
            }
        }
        this.suppressNextMapIdleSearch = false;
    }

    map_image_enter(index: number) {
        // Hover on list cards must NOT move the map camera — only enlarge the matching pin
        if (this.highlightedMapIndex != null && this.highlightedMapIndex !== index) {
            return;
        }
        const data = this.experienceData();
        if (!data?.[index]) {
            return;
        }
        this.hoveredMapIndex = index;
        data[index].map_image = this.buildMapPinIcon('highlight', data[index]);
        data[index].zindex = 800;
        this.cdref.detectChanges();
    }

    map_image_out(index: number) {
        if (this.hoveredMapIndex === index) {
            this.hoveredMapIndex = null;
        }
        if (this.highlightedMapIndex != null) {
            // Keep focused pin large; restore hover pin only if it wasn't the focused one
            if (this.highlightedMapIndex !== index) {
                const data = this.experienceData();
                if (data?.[index]) {
                    data[index].map_image = this.buildMapPinIcon('default', data[index]);
                    data[index].zindex = 1;
                    this.cdref.detectChanges();
                }
            }
            return;
        }
        const data = this.experienceData();
        if (!data?.[index]) {
            return;
        }
        data[index].map_image = this.buildMapPinIcon('default', data[index]);
        data[index].zindex = 1;
        this.cdref.detectChanges();
    }

    onMouseClick(index: number, marker: MapMarker, event?: google.maps.MapMouseEvent) {
        // Prevent map background handler from immediately closing the popover
        event?.stop?.();
        event?.domEvent?.stopPropagation?.();

        // Pan to pin (map control gesture) — do not dim the listing
        this.focusMapPin(index, undefined, { pan: true });
        const data = this.experienceData();
        const record = data?.[index];
        if (!record) {
            return;
        }

        this.activeMapPinIndex = index;
        this.activeMapPinRecord = record;
        this.closeLegacyInfoWindows();

        setTimeout(() => this.positionMapPinPopover(marker), 40);
        setTimeout(() => this.positionMapPinPopover(marker), 200);
    }

    onMapBackgroundClick() {
        this.closeMapPinPopover();
    }

    onMapIdleWhilePopoverOpen() {
        if (this.activeMapPinIndex == null || !this.googleMap?.googleMap) {
            return;
        }
        const data = this.experienceData();
        const record = data?.[this.activeMapPinIndex];
        if (!record) {
            return;
        }
        const lat = +record.latitude;
        const lng = +record.longitude;
        if (isNaN(lat) || isNaN(lng)) {
            return;
        }
        this.positionMapPinPopoverFromLatLng({ lat, lng });
    }

    closeMapPinPopover() {
        this.activeMapPinIndex = null;
        this.activeMapPinRecord = null;
        this.closeLegacyInfoWindows();
    }

    pinPopoverImage(pin: any): string {
        if (pin?.gallery_list?.length && pin.gallery_list[0]?.image) {
            return pin.gallery_list[0].image;
        }
        if (pin?.image_url) {
            return pin.image_url + '?height=240';
        }
        return 'assets/images/vebo_find_img.png';
    }

    private closeLegacyInfoWindows() {
        if (this.activeInfoWindow) {
            try {
                this.activeInfoWindow.close();
            } catch { /* ignore */ }
            this.activeInfoWindow = null;
        }
        this.previousIW = '';
        this.currentIW = '';
    }

    infoWindowClose(_infoWindow?: MapInfoWindow) {
        this.closeMapPinPopover();
    }

    private closeActiveInfoWindow() {
        this.closeMapPinPopover();
    }

    /**
     * Place the pin card fully inside the map wrap, smartly around the pin:
     * prefer above; flip below if near top; clamp horizontally so it never spills left/right.
     */
    private positionMapPinPopover(marker: MapMarker) {
        const position = marker?.getPosition?.();
        if (!position) {
            return;
        }
        this.positionMapPinPopoverFromLatLng(position);
    }

    private positionMapPinPopoverFromLatLng(latLng: google.maps.LatLng | google.maps.LatLngLiteral) {
        if (!this.isBrowser || !this.googleMap?.googleMap || !this.mapCanvasWrap?.nativeElement) {
            return;
        }

        const point = this.latLngToWrapPixel(latLng);
        if (!point) {
            return;
        }

        const wrap = this.mapCanvasWrap.nativeElement;
        const wrapW = wrap.clientWidth;
        const wrapH = wrap.clientHeight;
        const cardW = this.mapPinCardWidth;
        const cardH = this.mapPinCardHeight;
        const pad = 10;
        const pinGap = 14;

        let left = point.x - cardW / 2;
        left = Math.max(pad, Math.min(left, wrapW - cardW - pad));

        const spaceAbove = point.y - pad;
        const spaceBelow = wrapH - point.y - pad;
        let placement: 'above' | 'below' = 'above';
        let top: number;

        if (spaceAbove >= cardH + pinGap || spaceAbove >= spaceBelow) {
            placement = 'above';
            top = point.y - cardH - pinGap;
        } else {
            placement = 'below';
            top = point.y + pinGap + 8;
        }
        top = Math.max(pad, Math.min(top, wrapH - cardH - pad));

        this.mapPinPopoverPos = { left, top, placement };
        this.cdref.detectChanges();
    }

    private latLngToWrapPixel(latLng: google.maps.LatLng | google.maps.LatLngLiteral): { x: number; y: number } | null {
        const map = this.googleMap?.googleMap;
        if (!map || !this.mapCanvasWrap?.nativeElement) {
            return null;
        }

        if (!this.mapPixelOverlay) {
            const overlay = new google.maps.OverlayView();
            overlay.draw = () => { /* no-op */ };
            overlay.onAdd = () => { /* no-op */ };
            overlay.onRemove = () => { /* no-op */ };
            overlay.setMap(map);
            this.mapPixelOverlay = overlay;
        } else if (this.mapPixelOverlay.getMap() !== map) {
            this.mapPixelOverlay.setMap(map);
        }

        const projection = this.mapPixelOverlay.getProjection();
        if (!projection) {
            setTimeout(() => this.positionMapPinPopoverFromLatLng(latLng), 80);
            return null;
        }

        const ll = latLng instanceof google.maps.LatLng
            ? latLng
            : new google.maps.LatLng(latLng.lat, latLng.lng);
        const containerPixel = projection.fromLatLngToContainerPixel(ll);
        if (!containerPixel) {
            return null;
        }

        return { x: containerPixel.x, y: containerPixel.y };
    }

    mapPageChanged(eve: number) {
        if (!eve || eve < 1 || eve > this.mapTotalPages || eve === this.page) {
            return;
        }
        this.closeActiveInfoWindow();
        this.highlightedMapIndex = null;
        this.hoveredMapIndex = null;
        this.fitbounds = !this.search_with_map;
        this.page = eve;
        // Pagination within current map area — don't re-fit the camera
        this.skipFitOnNextMapLoad = true;
        // Server-side page fetch via parent get-experience-by-location (page + per_page)
        this.pageChangeFromChild.emit(eve);
        if (this.isBrowser) {
            const listEl = this.el.nativeElement.querySelector('.map-list-scroll');
            if (listEl?.scrollIntoView) {
                listEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }

    removeClass(i: number, id: string) {
        if (this.isBrowser) {
            const element = document.getElementById(id + i);
            if (element) {
                element.classList.remove('active');
            }
        }
    }

    add_gift_event(_e: any) {
        this.router.navigate(['/gift-card']);
    }

    openDialog(_record?: any, _price?: any, _type?: any, _tax: any = 0, _data: any = '') {
        // Buy/registry dialogs are owned by parent pages; grid already references this stub.
    }

    private safeReplaceState(url: string): void {
        const raw = String(url || '');
        const q = raw.indexOf('?');
        const path = q >= 0 ? raw.slice(0, q) : raw;
        const filters: Record<string, string> = {};
        if (q >= 0) {
            new URLSearchParams(raw.slice(q + 1)).forEach((value, key) => {
                filters[key] = value;
            });
        }
        this.canonicalService.replaceStateWithFilters(this._location, path, filters);
    }

    ngOnInit(): void {
        this.syncSelectedDateFromInputs();
        this.currentComponentRoute = this.router?.url;
        this.hydrateBadgeIdFromQueryParams();
        this.fetchBadges();
        if (this.view_on_map) {
            this.setMapViewBodyClass(true);
        }
        this.syncFilterPinPageClass();
        if (this.isGiftCategoryPage || this.isHighLevelCategoryPage) {
            this.scheduleLocationModalPrompt();
        }

        if (this.videoElement && this.videoElement.nativeElement) {
            this.videoElement.nativeElement.load(); // play video
        }

        this.route.params.subscribe(params => {
            this.country_slug = params['country'];
            this.state_slug = params['state'];
        });

        if (this.isHighLevelCategoryPage && !(this.categoryList?.length > 0)) {
            let slug = this.slug;

            let category_slug_for_experience = {
                'category_for': 'experience',
                'type': 'higher-level-category'
            };

            this.mainService.get_categories(category_slug_for_experience).subscribe(res => {
                this.catList = res.data;
                for (let i = 0; i < this.catList.length; i++) {
                    if (this.catList[i].slug == slug && this.catList[i].child_categories && this.catList[i].child_categories.length > 0) {
                        this.categoryList = this.catList[i].child_categories;
                        break;
                    }
                }
                if (this.catList && this.catList?.length > 0) {
                    // this.preselectCategoryFromSlug(slug)
                    this.calculateCategoryIndex();
                }
            });

        } else if (this.isHighLevelCategoryPage) {
            this.calculateCategoryIndex();
        }

        if (this.currentComponentRoute.includes('/gifts')) {
            if (this.categoryList?.length > 0) {
                this.calculateCategoryIndexForGiftIdeas();
            } else {
                let slug = this.slug;
                let requestbody = {
                    'category_for': 'experience',
                    'type': 'gift-ideas'
                };
                this.categoryData = this.mainService.get_categories(requestbody).subscribe(res => {
                    this.categoryList = res.data;
                    if (this.categoryList && this.categoryList?.length > 0) {
                        this.calculateCategoryIndexForGiftIdeas();
                    }
                });
            }
        }

        this.locationData = this.state.countries$.subscribe((data) => {
            if (data && data.length > 0) {
                this.countries = data;
                // 🔥 Build dropdown list (NEW)
                this.buildModalLocationList();
                // let selectedCountryIndex = this.countries.findIndex(
                //     (country: any) => country.slug === this.slug
                // );
                // this.selectedCountry(selectedCountryIndex, true);
            }
        });
    }

    calculateCategoryIndex() {
        this.currentHighlvlSlug = this.bridgeService.slug();

        const currentCitySlug = this.bridgeService.state();
        if (currentCitySlug != '') {
            if (this.selectedChlidLocations && this.selectedChlidLocations.length > 0) {
                this.selectedCityIndex = this.selectedChlidLocations.findIndex(
                    (place: any) => place.slug === currentCitySlug
                );
                this.citySelected = this.selectedChlidLocations[this.selectedCityIndex]
            } else {
                this.selectedCityIndex = null;
            }
        }

    }

    calculateCategoryIndexForGiftIdeas() {
        const currentcategory = this.giftCategory.slug();
        if (this.filteredCategoryList && this.filteredCategoryList.length > 0) {
            this.selectedCategoryIndex = this.filteredCategoryList.findIndex(
                (cat: any) => cat.slug === currentcategory
            );
            if (this.selectedCategoryIndex === -1) {
                // Draft preview: slug is not in the published get-category list — do not 404
                if (this.isContentPreviewMode()) {
                    this.selectedCategoryIndex = null;
                    return;
                }
                this.routeNotFound.emit();
                return;
            }
        } else {
            this.selectedCategoryIndex = null;
        }
    }

    /** Admin draft preview (?preview_token=&expires=) — same idea as blog preview */
    private isContentPreviewMode(): boolean {
        if (this.isPreview) {
            return true;
        }
        const qp = this.route?.snapshot?.queryParams || {};
        return !!(qp['preview_token'] && qp['expires']);
    }

    buildModalLocationList() {

        this.modalLocationList = [];

        this.countries.forEach((country: any, cIndex: number) => {

            // ======================================================
            // LEVEL 1 → COUNTRY
            // ======================================================

            this.modalLocationList.push({
                id: country.id,
                name: country.name,
                slug: country.slug,
                type: 'country',
                level: 1,

                parentCountryIndex: cIndex,
                parentCountrySlug: country.slug,
                parentCountryName: country.name,

                raw: country
            });

            // ======================================================
            // GET LEVEL 2 DATA
            // ======================================================

            let states: any[] = [];

            // US structure
            if (country.slug === 'united-states') {

                states = (country.child_locations || [])
                    .flatMap((division: any) => division.division_data || []);

            }

            // Normal structure
            else {

                states = country.child_locations || [];

            }

            // ======================================================
            // LEVEL 2 → STATE / PROVINCE
            // ======================================================

            states.forEach((state: any, sIndex: number) => {

                this.modalLocationList.push({
                    id: state.id,
                    name: state.name,
                    slug: state.slug,

                    type: 'state',
                    level: 2,

                    parentCountryIndex: cIndex,
                    parentCountrySlug: country.slug,
                    parentCountryName: country.name,

                    parentStateSlug: state.slug,
                    parentStateName: state.name,

                    raw: state
                });

                // ======================================================
                // LEVEL 3 → CITIES
                // ======================================================

                const cities = state.child_locations || [];

                cities.forEach((city: any) => {

                    this.modalLocationList.push({
                        id: city.id,
                        name: city.name,
                        slug: city.slug,

                        type: 'city',
                        level: 3,

                        parentCountryIndex: cIndex,
                        parentCountrySlug: country.slug,
                        parentCountryName: country.name,

                        parentStateSlug: state.slug,
                        parentStateName: state.name,

                        raw: city
                    });

                });

            });

        });

        // default filtered list
        this.filteredModalLocationList = [...this.modalLocationList];
        if (!this.isLocationModalOpen || !this.hasSelectedModalItem()) {
            this.restoreSelectedModalItem();
        }
    }

    /** True when the location autocomplete is holding a real location, not [] or null. */
    private hasSelectedModalItem(): boolean {
        const item = this.selectedModalItem;
        return !!item && !Array.isArray(item) && !!item.slug;
    }

    /**
     * Point the location autocomplete at the location already applied
     * (city, state, or country) so reopening the modal shows it as selected.
     */
    private restoreSelectedModalItem(): void {
        if (!Array.isArray(this.modalLocationList) || this.modalLocationList.length === 0) {
            return;
        }

        const city: any = this.selectedCity;
        if (city?.slug && (city.level === 3 || city.type === 'city')) {
            const match = this.modalLocationList.find((item: any) =>
                item.type === 'city'
                && item.slug === city.slug
                && (!city.parentStateSlug || item.parentStateSlug === city.parentStateSlug)
            );
            if (match) {
                this.selectedModalItem = match;
                return;
            }
        }

        const child = this.citySelected;
        const country = this.countrySelected;
        if (child?.slug) {
            const match = this.modalLocationList.find((item: any) =>
                item.type === 'state'
                && item.slug === child.slug
                && (!country?.slug || item.parentCountrySlug === country.slug)
            );
            if (match) {
                this.selectedModalItem = match;
                return;
            }
        }

        if (country?.slug && country.level !== 3 && country.type !== 'city') {
            const match = this.modalLocationList.find((item: any) =>
                item.type === 'country' && item.slug === country.slug
            );
            if (match) {
                this.selectedModalItem = match;
                return;
            }
        }
    }

    changeView() {
        if (!this.isMobileView) {
            this.gridView = true;
            return;
        }
        this.gridView = !this.gridView;
        this.closeAllFilterSidebars();
        this.cdref.detectChanges();
    }

    toggleGridSidebar() {
        this.sidebarOpen.update(v => !v);
        this.syncBodyMenuOpenedClass();
    }

    closeGridSidebar() {
        this.sidebarOpen.set(false);
        this.syncBodyMenuOpenedClass();
    }

    toggleSidebar() {
        this.sidebarListOpen.update(v => !v);
        this.syncBodyMenuOpenedClass();
    }

    closeSidebar() {
        this.sidebarListOpen.set(false);
        this.syncBodyMenuOpenedClass();
    }

    closeAllFilterSidebars() {
        this.sidebarOpen.set(false);
        this.sidebarListOpen.set(false);
        this.syncBodyMenuOpenedClass();
    }

    private syncBodyMenuOpenedClass() {
        if (!this.isBrowser) {
            return;
        }
        const isOpen = this.sidebarOpen() || this.sidebarListOpen();
        if (isOpen) {
            document.body.classList.add('menu-opened');
            document.body.style.overflow = 'hidden';
        } else {
            document.body.classList.remove('menu-opened');
            document.body.style.overflow = '';
        }
    }

    ngAfterViewInit() {
        this.viewInitialized = true;
        if (this.isBrowser) {
            this.showVideo();
        }
        this.cdref.detectChanges();
    }

    /** detectChanges only when the view is attached (constructor BreakpointObserver emit is too early). */
    private safeDetectChanges(): void {
        if (!this.viewInitialized) {
            return;
        }
        this.cdref.detectChanges();
    }

    setCurrentLocation() {
        if (this.isBrowser) {
            localStorage.setItem("currentPage", this.router?.url)
        }
    }

    onPageChange(event: any) {
        // this.first = event.first;
        // this.rows = event.rows;
        const newPage = Math.floor(event.first / event.rows) + 1;
        this.pageChangeFromChild.emit(newPage);
        this.updateParamsAndScroll();
    }

    buildThresholdList() {
        const thresholds = [];
        const numSteps = 20;
        for (let i = 1; i <= numSteps; i++) {
            thresholds.push(i / numSteps);
        }
        return thresholds;
    }

    showVideo() {
        if (this.isBrowser) {
            const options: IntersectionObserverInit = {
                root: null,
                threshold: this.buildThresholdList()
            };

            this.ngZone.runOutsideAngular(() => {
                this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

                this.videos.forEach(videoRef => {
                    const video = videoRef.nativeElement;
                    video.preload = 'metadata'; // prevent network overload
                    video.pause(); // ensure all are paused initially
                    this.observer.observe(video);
                });

                // Also re-evaluate on resize/scroll in case layout shifts
                window.addEventListener('resize', this.recheckObserver);
                window.addEventListener('scroll', this.recheckObserver, true);
            });
        }
    }

    private handleIntersect(entries: IntersectionObserverEntry[]) {
        let maxRatio = 0;
        let mostVisibleVideo: HTMLVideoElement | null = null;

        entries.forEach(entry => {
            const ratio = entry.intersectionRatio;
            if (ratio > maxRatio) {
                maxRatio = ratio;
                mostVisibleVideo = entry.target as HTMLVideoElement;
            }
        });

        if (mostVisibleVideo) {
            this.videos.forEach(videoRef => {
                const video = videoRef.nativeElement;
                if (video === mostVisibleVideo) {
                    video.play().catch(() => { });
                } else {
                    video.pause();
                }
            });
        }
    }

    private recheckObserver = () => {
        this.videos.forEach(videoRef => {
            const video = videoRef.nativeElement;
            this.observer.unobserve(video);
            this.observer.observe(video);
        });
    };

    updateParamsAndScroll() {
        if (this.isBrowser) {
            setTimeout(() => {
                const target = document.getElementById('scrollTarget');

                if (target) {
                    const offset = 200; // extra scroll
                    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 500);
        }
    }

    selectedCountry(index: number, isAutoSelect: boolean = false, reapply: boolean = false, silent: boolean = false) {
        if (index !== null && !reapply) {
            this.selectedModalItem = [];
            this.selectedCity = [];
        }
        const selected: any = this.countries[index];
        this.countrySelected = selected;
        this.selectedCityIndex = null;
        this.citySelected = '';
        if (this.selectedCountryIndex === index && !reapply) {
            this.selectedCountryIndex = null;
            this.countrySelected = '';
            this.selectedCityIndex = null;
            this.citySelected = '';
            this.selectedChlidLocations = [];
            if (this.isHighLevelCategoryPage) {
                if (this.citySelected && this.citySelected?.slug) {
                    this.bridgeService.setSelectedLocation(this.citySelected.slug);
                    this.bridgeService.setExpData([]);
                } else {
                    this.bridgeService.setSelectedLocation('');
                    this.bridgeService.setCountrySlug('');
                    this.bridgeService.setState('');
                    this.bridgeService.setExpData([]);
                    this.bridgeService.setPage(1);
                    this.safeReplaceState(`/experience/${this.bridgeService.slug()}`)
                }
            }

            if (this.isGiftCategoryPage) {
                this.giftCategory.setCountrySlug('');
                this.giftCategory.setSelectedLocation('');
                this.giftCategory.setState('')
                this.giftCategory.setPage(1);

                const url = '/gifts/' + [
                    this.giftCategory.slug(),
                    this.giftCategory.country_slug()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
                if (this.isBrowser) {
                    let loc_slug = this.giftCategory.country_slug();
                    sessionStorage.setItem('selected_loc_slug', loc_slug);
                }
            }

            if (this.isLocationRegionPage) {
                this.locationBridge.setPage(1);
                this.locationBridge.setResult([]);
                const url = '/location-region/' + [
                    this.locationBridge.slug(),
                    this.locationBridge.placeSlug()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);

            }
            if (this.currentComponentRoute.includes('/location-region') && this.getRouteType() === 'city') {

                if (this.citySelected && this.citySelected?.slug) {
                    this.locationCatBdridge.setCategorySlug(this.citySelected.slug);
                    this.locationCatBdridge.setResultExp([]);
                } else {
                    let slug = this.router?.url?.split('/')[3]?.split('?')[0];
                    this.locationCatBdridge.setCategorySlug(slug);
                    this.locationCatBdridge.setResultExp([]);

                }
            }

            if (this.isBrowser && !isAutoSelect && !silent) {
                setTimeout(() => {
                    this.requestListingRefresh({ resetPage: true });
                }, 10);
            }
        } else {
            this.selectedCountryIndex = index;
            if (this.selectedModalItem && this.selectedModalItem?.level === 3) {
                this.countrySelected = this.selectedModalItem;
            }
            if (this.isHighLevelCategoryPage) {
                if (this.selectedModalItem && this.selectedModalItem?.level === 3) {
                    this.bridgeService.setCountrySlug(this.countrySelected.parentCountrySlug);
                    this.bridgeService.setState(this.countrySelected.parentStateSlug);
                    this.bridgeService.setSelectedLocation(this.countrySelected.slug);
                    this.bridgeService.setPage(1);
                    this.bridgeService.setExpData([]);
                    const url = '/experience/' + [
                        this.bridgeService.slug(),
                        this.bridgeService.countrySlug(),
                        this.bridgeService.state()].filter(Boolean).join('/');
                    this.safeReplaceState(url);
                    if (this.isBrowser) {
                        let loc_slug = this.bridgeService.countrySlug() + '/' + this.bridgeService.state();
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                } else {
                    this.safeReplaceState(`/experience/${this.bridgeService.slug()}/${this.countrySelected.slug}`);
                    this.bridgeService.setSelectedLocation(this.countrySelected.slug);
                    this.bridgeService.setCountrySlug(this.countrySelected.slug);
                    this.bridgeService.setState('');
                    this.bridgeService.setPage(1);
                    this.bridgeService.setExpData([]);
                    if (this.isBrowser) {
                        let loc_slug = this.countrySelected.slug;
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                }
            }

            if (this.isGiftCategoryPage) {
                if (this.selectedModalItem && this.selectedModalItem?.level === 3) {
                    this.giftCategory.setCountrySlug(this.countrySelected.parentCountrySlug);
                    this.giftCategory.setState(this.countrySelected.parentStateSlug);
                    this.giftCategory.setSelectedLocation(this.countrySelected.slug);
                    this.giftCategory.setPage(1);

                    const url = '/gifts/' + [
                        this.giftCategory.slug(),
                        this.giftCategory.country_slug(),
                        this.giftCategory.state()
                    ].filter(Boolean).join('/');
                    this.safeReplaceState(url);
                    if (this.isBrowser) {
                        let loc_slug = this.giftCategory.country_slug() + '/' + this.giftCategory.state();
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                } else {
                    this.giftCategory.setCountrySlug(this.countrySelected.slug);
                    this.giftCategory.setSelectedLocation(this.countrySelected.slug);
                    this.giftCategory.setState('');
                    this.giftCategory.setPage(1);

                    const url = '/gifts/' + [
                        this.giftCategory.slug(),
                        this.giftCategory.country_slug()
                    ].filter(Boolean).join('/');
                    this.safeReplaceState(url);
                    if (this.isBrowser) {
                        let loc_slug = this.giftCategory.country_slug();
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                }

            }

            if (this.isLocationRegionPage) {
                this.locationBridge.setPage(1);
                this.locationBridge.setPlaceSlug('');
                this.router.navigate(
                    ['location-region', this.countrySelected.slug]
                );
            }

            if (this.isLocationRegionCategoryPage) {
                this.locationCatBdridge.setCategorySlug(this.countrySelected.slug);
                this.locationCatBdridge.setResultExp([]);
                this.router.navigate(['location-region/' + this.countrySelected.slug]);

            }

            if (this.isBrowser && !isAutoSelect && !silent) {
                setTimeout(() => {
                    this.requestListingRefresh({ resetPage: true });
                }, 10)
            }
            if (selected?.slug === "united-states") {
                const divisions = selected.child_locations || [];
                let merged = divisions.flatMap(
                    (d: any) => d.division_data || []
                );
                merged = merged.sort(
                    (a: any, b: any) => a.name.localeCompare(b.name)
                );
                this.selectedChlidLocations = merged;
                return;
            }
            this.selectedChlidLocations = selected?.child_locations || [];
        }
    }

    selectedLocation(index: number, isAutoSelect: boolean = false, reapply: boolean = false, silent: boolean = false) {
        const selected: any = this.selectedChlidLocations[index];
        this.citySelected = selected

        if (this.selectedCityIndex == index && !reapply) {
            this.selectedCityIndex = null;
            this.citySelected = '';
            if (this.isHighLevelCategoryPage) {
                if (this.countrySelected && this.countrySelected.slug) {
                    this.bridgeService.setSelectedLocation(this.countrySelected.slug);
                    this.bridgeService.setState('');
                    this.bridgeService.setExpData([]);
                    this.bridgeService.setPage(1);
                    this.safeReplaceState(`/experience/${this.bridgeService.slug()}/${this.bridgeService.countrySlug()}`);
                } else {
                    if (this.bridgeService.countrySlug() != '') {
                        const val = this.bridgeService.countrySlug();
                        this.bridgeService.setSelectedLocation(val);
                        this.bridgeService.setState('');

                    } else {
                        this.bridgeService.setSelectedLocation('');
                    }
                    this.bridgeService.setExpData([]);
                    this.safeReplaceState(`/experience/${this.bridgeService.slug()}/${this.bridgeService.countrySlug()}`);
                }

                if (this.isBrowser) {
                    let loc_slug = this.bridgeService.countrySlug();
                    sessionStorage.setItem('selected_loc_slug', loc_slug);
                }
            }

            if (this.isGiftCategoryPage) {
                this.giftCategory.setPage(1);
                this.giftCategory.setSelectedLocation('');
                this.giftCategory.setState('');
                const url = '/gifts/' + [
                    this.giftCategory.slug(),
                    this.giftCategory.country_slug(),
                    this.giftCategory.state()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
                if (this.isBrowser) {
                    let loc_slug = this.giftCategory.country_slug() + '/' + this.giftCategory.state();
                    sessionStorage.setItem('selected_loc_slug', loc_slug);
                }
            }

            if (this.isLocationRegionPage) {
                this.locationBridge.setPlaceSlug('');
                this.locationBridge.setPage(1);
                this.locationBridge.setResult([]);
                const url = '/location-region/' + [
                    this.locationBridge.slug(),
                    this.locationBridge.placeSlug()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
            }

            if (this.isLocationRegionCategoryPage) {
                let slug = this.router?.url?.split('/')[4]?.split('?')[0];
                this.locationCatBdridge.setPage(1);
                this.locationCatBdridge.setCategorySlug(slug);
            }

        }
        else {
            this.selectedCityIndex = index;

            if (this.isHighLevelCategoryPage) {
                this.bridgeService.setSelectedLocation(this.citySelected.slug);
                this.bridgeService.setState(this.citySelected.slug);
                this.bridgeService.setPage(1);
                this.bridgeService.setExpData([]);
                if (!isAutoSelect) {
                    this.safeReplaceState(`/experience/${this.bridgeService.slug()}/${this.bridgeService.countrySlug()}/${this.citySelected.slug}`);
                    if (this.isBrowser) {
                        let loc_slug = this.bridgeService.countrySlug() + '/' + this.citySelected.slug;
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                } else {
                    const url = '/experience/' + [
                        this.bridgeService.slug(),
                        this.bridgeService.countrySlug(),
                        this.bridgeService.state()].filter(Boolean).join('/');
                    this.safeReplaceState(url);
                    if (this.isBrowser) {
                        let loc_slug = this.bridgeService.countrySlug() + '/' + this.bridgeService.state();
                        sessionStorage.setItem('selected_loc_slug', loc_slug);
                    }
                }
            }

            if (this.isGiftCategoryPage) {
                this.giftCategory.setPage(1);
                this.giftCategory.setSelectedLocation(this.citySelected.slug);
                this.giftCategory.setState(this.citySelected.slug);
                const url = '/gifts/' + [
                    this.giftCategory.slug(),
                    this.giftCategory.country_slug(),
                    this.giftCategory.state()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
                if (this.isBrowser) {
                    let loc_slug = this.giftCategory.country_slug() + '/' + this.giftCategory.state();
                    sessionStorage.setItem('selected_loc_slug', loc_slug);
                }
            }

            if (this.isLocationRegionPage) {
                this.locationBridge.setPlaceSlug(this.citySelected.slug);
                this.locationBridge.setPage(1);
                this.locationBridge.setResult([]);
                const url = '/location-region/' + [
                    this.locationBridge.slug(),
                    this.locationBridge.placeSlug()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
            }

            if (this.isLocationRegionCategoryPage) {
                // this.locationCatBdridge.setPage(1);
                // this.locationCatBdridge.setCategorySlug(this.citySelected.slug);
                this.locationCatBdridge.setState(this.citySelected.slug);
                // this.locationCatBdridge.setResultExp([]);
                const url = '/location-region/' + [
                    this.locationCatBdridge.country(),
                    this.locationCatBdridge.state()].filter(Boolean).join('/');
                this.router.navigate([url]);
            }

        }
        if (this.isBrowser && !silent) {
            setTimeout(() => {
                this.requestListingRefresh({ resetPage: true });
            }, 100)
        }
    }

    displayGiftCategorySelected(index: number) {
        this.categoryIndex = index
        const selected: any = this.filteredCategoryList[index];
        const url = this.router.url.split('?')[0];
        const segments = url.split('/');
        const root = segments[1];
        // this.updateParamsAndScroll();
        this.selectedCategory = selected.slug;
        this.selectedCategoryIndex = index;
        this.selectedCategoryName = selected;

    }

    selectedCategoryfn(index: number, silent: boolean = false) {
        this.categoryIndex = index;
        // this.pageChangeFromChild.emit(1);
        let filteredcatList = this.filteredCategoryList
        const selected: any = this.filteredCategoryList[index];
        const url = this.router.url.split('?')[0];
        const segments = url.split('/');
        const root = segments[1];
        if (this.selectedCategoryIndex === index) {
            this.categoryIndex = '';
            this.selectedCategoryIndex = null;
            this.selectedCategoryName = null;
            if (this.isGiftCategoryPage) {
                const slug = this.router?.url?.split('/')[2]?.split('?')[0];
                this.giftCategory.setSlug(slug);
            }
            if (this.isHighLevelCategoryPage) {
                this.selectedCategory = this.router?.url?.split('/')[2]?.split('?')[0];
                this.bridgeService.setExpData([]);
                this.bridgeService.setPage(1);
                const url = '/experience/' + [
                    this.bridgeService.slug(),
                    this.bridgeService.countrySlug(),
                    this.bridgeService.state()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url)
                this.bridgeService.setCategorySlug(this.selectedCategory);
            }
        }
        else {
            this.selectedCategory = selected.slug;
            this.selectedCategoryName = selected;
            this.selectedCategoryIndex = index;
            if (this.isGiftCategoryPage) {
                this.giftCategory.setPage(1);
                const url = '/gifts/' + [
                    this.selectedCategory,
                    this.giftCategory.country_slug(),
                    this.giftCategory.state()
                ].filter(Boolean).join('/');
                this.router.navigate([url]);
            }
            if (this.isHighLevelCategoryPage) {
                this.bridgeService.setExpData([]);
                this.bridgeService.setPage(1);
                const url = '/experience/' + [
                    this.bridgeService.slug(),
                    this.bridgeService.countrySlug(),
                    this.bridgeService.state(),
                ].filter(Boolean).join('/');
                this.safeReplaceState(url)
                this.bridgeService.setCategorySlug(this.selectedCategory);
                this.toggleExpAccordion('sub-category')
            }
        }
        if (this.isBrowser && !silent) {
            setTimeout(() => {
                this.requestListingRefresh({ resetPage: true });
            }, 10)
        }

    }

    selectedHighLevelCategory(index: number, isInternal: boolean = false, silent: boolean = false) {
        // this.pageChangeFromChild.emit(1);
        const selected: any = this.highLevelCategoryList[index];
        if (this.highLevelCategoryIndex == index) {
            this.highLevelCategoryIndex = null;
            this.highLevelCatId = 0

            if (this.isHighLevelCategoryPage) {
                const slug = this.router?.url?.split('/')[2]?.split('?')[0];
                this.bridgeService.setSlug(slug)
            }
            if (this.isGiftCategoryPage) {
                const slug = this.router?.url?.split('/')[2]?.split('?')[0];
                this.giftCategory.setCategorySlug(slug);
                this.giftCategory.setPage(1);
                const url = '/gifts/' + [
                    this.slug,
                    this.giftCategory.country_slug(),
                    this.bridgeService.state()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
            }
            if (this.isLocationRegionPage) {
                this.locationBridge.setPage(1);
                this.locationBridge.setCategoryId(0);
                this.locationBridge.setResult([]);
            }
            if (this.isLocationRegionCategoryPage) {
                this.locationCatBdridge.setPage(1);
                this.locationCatBdridge.setCategoryId(0);
                this.locationCatBdridge.setResultExp([]);
            }
        } else {
            this.highLevelCategoryIndex = index
            this.highLevelCatId = selected;
            if (this.isHighLevelCategoryPage) {
                const url = '/experience/' + [this.highLevelCatId?.slug, this.bridgeService.countrySlug(), this.bridgeService.state()]
                    .filter(Boolean)
                    .join('/');
                this.router.navigate([url]);
                this.bridgeService.setCategorySlug('');
            }

            if (this.isGiftCategoryPage) {
                this.giftCategory.setCategorySlug(this.highLevelCatId.slug);
                this.giftCategory.setPage(1);
                const url = '/gifts/' + [
                    this.slug,
                    this.giftCategory.country_slug(),
                    this.giftCategory.state()
                ].filter(Boolean).join('/');
                this.safeReplaceState(url);
            }

            if (this.isLocationRegionPage) {
                this.locationBridge.setPage(1);
                this.locationBridge.setCategoryId(this.highLevelCatId?.id);
            }

            if (this.isLocationRegionCategoryPage) {
                this.locationCatBdridge.setPage(1);
                this.locationCatBdridge.setCategoryId(this.highLevelCatId?.id);
                this.locationCatBdridge.setResultExp([]);
            }

        }
        if (this.isBrowser && !isInternal && !silent) {
            setTimeout(() => {
                this.requestListingRefresh({ resetPage: true });
            }, 10)
        }
    }

    toggleExpAccordion(section: string) {
        const root = this.view_on_map
            ? (this.el.nativeElement.querySelector('#desktopFilterSidebarMap')
                || this.el.nativeElement.querySelector('.map-filters-sidebar')
                || this.el.nativeElement.querySelector('.exp-sidebar-mobile')
                || this.el.nativeElement)
            : this.el.nativeElement;
        const content = root.querySelector(`#exp-${section}-content`);
        const icon = root.querySelector(`#exp-${section}-icon`);
        if (!content || !icon) return;
        content.classList.toggle('exp-active');

        if (content.classList.contains('exp-active')) {
            icon.classList.remove('fa-chevron-down');
            icon.classList.add('fa-chevron-up');
        } else {
            icon.classList.remove('fa-chevron-up');
            icon.classList.add('fa-chevron-down');
        }
    }

    toggleExperienceFaq(faq: { id?: number | string }, index: number): void {
        const key = faq?.id != null ? faq.id : index;
        this.openExperienceFaqId = this.openExperienceFaqId === key ? null : key;
    }

    isExperienceFaqOpen(faq: { id?: number | string }, index: number): boolean {
        const key = faq?.id != null ? faq.id : index;
        return this.openExperienceFaqId === key;
    }

    toggleExpCheckbox(event: Event, checkboxId: string) {
        event.stopPropagation();
        const checkbox = this.el.nativeElement.querySelector(`#${checkboxId}`) as HTMLInputElement;
        if (!checkbox) return;

        // If user clicked directly on checkbox, do nothing extra
        if ((event.target as HTMLElement).tagName === 'INPUT') return;

        // Toggle manually
        checkbox.checked = !checkbox.checked;
    }

    add_gift_certificate() {
        this.router.navigate(['/gift-card']);
    }

    /** Heart for registry/bucket list — hide for vendors (role 3) and multi-option cards. */
    canShowRegistryHeart(record: any): boolean {
        if (!this.isUserLogin || !record) {
            return false;
        }
        const roleId = Number(this.authUser?.role_id);
        if (!roleId || roleId === 3) {
            return false;
        }
        if (!(roleId === 1 || roleId === 4 || roleId === 5 || roleId === 19)) {
            return false;
        }
        if (!(Number(record.experience_status) <= 1)) {
            return false;
        }
        if (!(Number(record.experience_type) <= 2)) {
            return false;
        }
        // SSR/resolver rows often omit child_experiences; treat missing as empty.
        if ((record.child_experiences?.length || 0) > 0) {
            return false;
        }
        return true;
    }

    isRegistryHeartFilled(record: any): boolean {
        return Number(record?.is_registry_status) === 1;
    }

    addToRegistry(exp_id, type, index) {
        this.experienceData()[index].is_show_ckbx = 1;     // show vebo V image.
        this.addexperience.addExperienceRegistry(exp_id, type, this.token).subscribe(res => {
            if (res.response == 'success') {
                this.messageService.sendTotalMessage(res.data);
                this.experienceData()[index].is_show_ckbx = 0;    // hide vebo V image.
                this.experienceData()[index].experience_status_msg = res?.data?.experience_status_msg;
                this.experienceData()[index].add_reg_msg_class = res?.data?.add_reg_msg_class;
                this.experienceData()[index].added_registry_type = res?.data?.added_registry_type;
                this.experienceData()[index].experience_status = res?.data?.experience_status;
                this.experienceData()[index].is_registry_status = res?.data?.is_registry_status;

            } else if (res.response == 'error') {
            }
        });
    }

    exp_detail(event: Event, slug, id, exp_pos, request_type = '') {
        event.preventDefault();
        var page_no = (this.page == this.last_page) ? this.page + 1 : this.page;
        if (this.isBrowser) {
            let expId = id;
            sessionStorage.setItem('selected_exp_id', expId.toString());
            setTimeout(() => {
                this.router.navigate(['/experiences/' + slug]);
            }, 10)
        }
    }

    isPriceRangeSelected(gte: any, lte: any): boolean {
        if (!this.price_option) return false;
        return this.price_option.some(item => item.gte === gte && item.lte === lte);
    }

    togglePriceFilter(gte: any, lte: any) {
        if (gte === '' && lte === '') {
            this.price_option = [];
        } else {
            if (!this.price_option) {
                this.price_option = [];
            }
            const index = this.price_option.findIndex(item => item.gte === gte && item.lte === lte);
            if (index > -1) {
                this.price_option.splice(index, 1);
            } else {
                this.price_option.push({ gte, lte });
            }
        }

        this.price_optionChange.emit(this.price_option);
        this.updateParamsAndScroll();

        // Sync with service/bridge signals
        if (this.currentComponentRoute.includes('/experience')) {
            this.bridgeService.setPriceFilter(this.price_option);
        }
        if (this.currentComponentRoute.includes('/gifts')) {
            this.giftideaBridge.setPriceFilter(this.price_option);
        }
        if (this.currentComponentRoute.includes('/gifts/')) {
            this.giftCategory.setPriceFilter(this.price_option);
        }
        if (this.isLocationRegionPage) {
            this.locationBridge.setPriceFilter(this.price_option);
        }
        if (this.isLocationRegionCategoryPage) {
            this.locationCatBdridge.setPriceFilter(this.price_option);
        }

        this.requestListingRefresh({ resetPage: true });
    }

    /** Load Earn Your Spurs badges for the filter sidebar */
    fetchBadges(): void {
        const token = this.token || (this.isBrowser ? (localStorage.getItem('login_token') || '') : '');
        this.pageSectionService.getBadges({}, token).subscribe({
            next: (res) => {
                this.badges = this.normalizeBadgesResponse(res);
                this.badgesLoaded = true;
                this.syncBadgeSelectionFromId();
                this.safeDetectChanges();
            },
            error: () => {
                this.badges = [];
                this.badgesLoaded = true;
                this.safeDetectChanges();
            },
        });
    }

    private normalizeBadgesResponse(res: any): any[] {
        const candidates = [res?.data?.badges, res?.data, res?.badges, res];
        for (const candidate of candidates) {
            if (Array.isArray(candidate)) {
                return candidate;
            }
        }
        return [];
    }

    /** Restore badge_id from URL on load / reload */
    private hydrateBadgeIdFromQueryParams(): void {
        const qpId = this.route?.snapshot?.queryParams?.['badge_id'];
        if (qpId == null || qpId === '') {
            return;
        }
        const normalized = !isNaN(+qpId) ? +qpId : qpId;
        if (String(this.badge_id || '') === String(normalized)) {
            return;
        }
        this.badge_id = normalized;
        this.badge_idChange.emit(this.badge_id);
    }

    /** Match selected checkbox/chip to current badge_id (Input or query) */
    private syncBadgeSelectionFromId(): void {
        let id = this.badge_id;
        if (id == null || id === '') {
            const qpId = this.route?.snapshot?.queryParams?.['badge_id'];
            if (qpId != null && qpId !== '') {
                id = !isNaN(+qpId) ? +qpId : qpId;
                this.badge_id = id;
            }
        }
        if (id == null || id === '' || !this.badges?.length) {
            this.selectedBadgeIndex = null;
            this.selectedBadgeName = null;
            return;
        }
        const idx = this.badges.findIndex((b) => String(b?.id) === String(id));
        if (idx >= 0) {
            this.selectedBadgeIndex = idx;
            this.selectedBadgeName = this.badges[idx];
        } else {
            this.selectedBadgeIndex = null;
            this.selectedBadgeName = null;
        }
    }

    badgeDisplayName(badge: any): string {
        if (!badge) {
            return '';
        }
        return (badge.title || badge.name || badge.sub_title || '').toString().trim();
    }

    selectBadgeFilter(index: number): void {
        if (!this.badges?.[index]) {
            return;
        }
        if (this.selectedBadgeIndex === index) {
            this.selectedBadgeIndex = null;
            this.selectedBadgeName = null;
            this.badge_id = '';
            this.badge_idChange.emit(this.badge_id || '');
            this.syncBadgeQueryParam();
            this.updateParamsAndScroll();
            this.requestListingRefresh({ resetPage: true });
            return;
        }

        this.selectedBadgeIndex = index;
        this.selectedBadgeName = this.badges[index];
        this.badge_id = this.badges[index]?.id;
        const slug = this.badges[index]?.slug;
        if (!slug) {
            return;
        }
        const location = this.badgeShopLocationSlug();
        const queryParams: any = {};
        if (location) {
            queryParams.location = location;
        }
        navigateBadgeBrowse(this.router, this.badges[index], queryParams);
    }

    /** Most specific applied location filter, otherwise the current page slug. */
    private badgeShopLocationSlug(): string {
        const citySlug = this.citySelected?.slug;
        if (citySlug) {
            return citySlug;
        }
        if (this.placeSlug) {
            return this.placeSlug;
        }
        const countrySlug = this.countrySelected?.slug;
        if (countrySlug) {
            return countrySlug;
        }
        if (this.state_slug) {
            return this.state_slug;
        }
        if (this.country_slug) {
            return this.country_slug;
        }
        if (this.selected_location) {
            const last = String(this.selected_location).split('/').filter(Boolean).pop();
            if (last) {
                return last;
            }
        }
        return (this.slug || '').toString();
    }

    removeBadgeFilter(): void {
        if (this.selectedBadgeIndex == null && !this.badge_id) {
            return;
        }
        this.selectedBadgeIndex = null;
        this.selectedBadgeName = null;
        this.badge_id = '';
        this.badge_idChange.emit('');
        this.syncBadgeQueryParam();
        this.updateParamsAndScroll();
        this.requestListingRefresh({ resetPage: true });
    }

    private syncBadgeQueryParam(): void {
        if (!this.isBrowser) {
            return;
        }
        const nextParams: any = { badge_id: this.badge_id ? this.badge_id : null };
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: nextParams,
            queryParamsHandling: 'merge',
            replaceUrl: true,
        });
    }

    getPriceOptionLabel(option: any): string {
        if (option.gte === '' && option.lte === 100) {
            return '< $100';
        } else if (option.gte === 100 && option.lte === 250) {
            return '$100 - $250';
        } else if (option.gte === 250 && option.lte === 500) {
            return '$250 - $500';
        } else if (option.gte === 500 && option.lte === '') {
            return '$500+';
        }
        return '';
    }

    removePriceOption(option: any) {
        if (!this.price_option) return;
        const index = this.price_option.findIndex(item => item.gte === option.gte && item.lte === option.lte);
        if (index > -1) {
            this.price_option.splice(index, 1);
            this.price_optionChange.emit(this.price_option);
            // this.pageChangeFromChild.emit(1);
            this.updateParamsAndScroll();

            // Sync with service/bridge signals
            if (this.currentComponentRoute.includes('/experience')) {
                this.bridgeService.setPriceFilter(this.price_option);
            }
            if (this.currentComponentRoute.includes('/gifts')) {
                this.giftideaBridge.setPriceFilter(this.price_option);
            }
            if (this.currentComponentRoute.includes('/gifts/')) {
                this.giftCategory.setPriceFilter(this.price_option);
            }
            if (this.isLocationRegionPage) {
                this.locationBridge.setPriceFilter(this.price_option);
            }
            if (this.isLocationRegionCategoryPage) {
                this.locationCatBdridge.setPriceFilter(this.price_option);
            }

            if (this.isBrowser) {
                setTimeout(() => {
                    this.requestListingRefresh();
                }, 500);
            }
        }
    }

    atHomeExperiences(event) {
        this.at_home = event.target.checked;
        // this.first = 0;
        this.updateParamsAndScroll();
        if (this.isLocationRegionPage) {
            this.locationBridge.setAtHome(this.at_home);
            this.locationBridge.setPage(1);
        }
        if (this.currentComponentRoute.includes('/experience')) {
            this.page = 1;
            this.last_page = 1;
            this.current_page = 1;
            this.selected_date = '';
            this.bridgeService.setAtHome(this.at_home);
            this.bridgeService.setPage(1);
            this.bridgeService.setLastPage(1);
            this.bridgeService.setCurrentPage(1);
            this.experienceDataChange.emit([]);
        }
        if (this.currentComponentRoute.includes('/gifts')) {
            this.page = 1;
            this.last_page = 1;
            this.current_page = 1;
            this.giftideaBridge.setAtHome(this.at_home);
            this.giftideaBridge.setPage(1);
            this.giftideaBridge.setLastPage(1);
            this.giftideaBridge.setCurrentPage(1);
            this.experienceDataChange.emit([]);
        }
        if (this.currentComponentRoute.includes('/gifts/')) {
            this.page = 1;
            this.last_page = 1;
            this.current_page = 1;
            this.giftCategory.setAtHome(this.at_home);
            this.giftCategory.setPage(1);
            this.giftCategory.setLastPage(1);
            this.giftCategory.setCurrentPage(1);
            this.experienceDataChange.emit([]);
        }
        if (this.isBrowser) {
            setTimeout(() => {
                this.requestListingRefresh()
            }, 10);
        }
    }

    onChangeSearch(event) {
        // this.first = 0;
        console.log(event?.value, '======================');
        if (event && event?.value) {
            if (this.currentComponentRoute.includes('/experience')) {
                this.search_id = event?.value?.id;
                this.bridgeService.setSearchId(this.search_id);
                this.type = event?.value?.type;
                this.bridgeService.setType(this.type);
            }
            if (this.currentComponentRoute.includes('/gifts')) {
                this.search_id = event?.value?.id;
                this.type = event.value.type;
                this.giftideaBridge.setSearchId(this.search_id);
                this.giftideaBridge.setType(this.type);
            }
            if (this.currentComponentRoute.includes('/gifts/')) {
                this.search_id = event?.value?.id;
                this.type = event.value.type;
                this.giftCategory.setSearchId(this.search_id);
                this.giftCategory.setType(this.type);
            }
            if (this.currentComponentRoute.includes('/location-region')) {
                if (this.getRouteType() === 'region') {
                    this.search_id = event?.value?.id;
                    this.type = event?.value?.type;
                    this.locationBridge.setSearchId(this.search_id);
                    this.locationBridge.setType(this.type);
                }
                if (this.getRouteType() === 'city') {
                    this.search_id = event?.value?.id;
                    this.type = event?.value?.type;
                    this.locationCatBdridge.setType(this.type)
                    this.locationCatBdridge.setSearchId(this.search_id);
                }
            }
        } else {
            if (this.currentComponentRoute.includes('/experience')) {
                this.search_id = '';
                this.bridgeService.setSearchId(this.search_id);
                this.type = '';
                this.bridgeService.setType(this.type);
                this.searchedItem = '';
                this.searchedItemChange.emit(this.searchedItem);
            }
            if (this.currentComponentRoute.includes('/gifts')) {
                this.search_id = '';
                this.type = '';
                this.giftideaBridge.setSearchId(this.search_id);
                this.giftideaBridge.setType(this.type);
            }
            if (this.currentComponentRoute.includes('/gifts/')) {
                this.search_id = '';
                this.type = '';
                this.giftCategory.setSearchId(this.search_id);
                this.giftCategory.setType(this.type);
            }
            if (this.currentComponentRoute.includes('/location-region')) {
                if (this.getRouteType() === 'region') {
                    this.search_id = '';
                    this.type = '';
                    this.searchedItem = ''
                    this.locationBridge.setType(this.type);
                    this.locationBridge.setSearchId(this.search_id);
                    this.locationBridge.setSearchedItem(this.searchedItem);
                }
                if (this.getRouteType() === 'city') {
                    this.search_id = '';
                    this.type = '';
                    this.page = 1;
                    this.current_page = 0;
                    this.searchedItem = ''
                    this.locationCatBdridge.setType(this.type)
                    this.locationCatBdridge.setSearchId(this.search_id);
                    this.locationCatBdridge.setPage(this.page);
                    this.locationCatBdridge.setCurrentPage(this.current_page);
                    this.locationCatBdridge.setSearchedItem(this.searchedItem);
                }
            }
        }
        this.experienceDataChange.emit([]);
        if (this.currentComponentRoute.includes('/experience')) {
            this.last_page = 0;
            this.bridgeService.setLastPage(0);
            this.page = 1;
            this.bridgeService.setPage(1);
            this.current_page = 0;
            this.bridgeService.setCurrentPage(0);
        }
        if (this.currentComponentRoute.includes('/gifts')) {
            this.page = 1;
            this.last_page = 0;
            this.current_page = 0;
            this.giftideaBridge.setPage(1);
            this.giftideaBridge.setLastPage(0);
            this.giftideaBridge.setCurrentPage(0);
        }
        if (this.currentComponentRoute.includes('/gifts/')) {
            this.page = 1;
            this.last_page = 0;
            this.current_page = 0;
            this.giftCategory.setPage(1);
            this.giftCategory.setLastPage(0);
            this.giftCategory.setCurrentPage(0);
        }
        if (this.currentComponentRoute.includes('/location-region')) {
            if (this.getRouteType() === 'region') {
                this.page = 1;
                this.last_page = 0;
                this.current_page = 0;
                this.locationBridge.setPage(this.page);
                this.locationBridge.setLastPage(this.last_page);
                this.locationBridge.setCurrentPage(this.current_page);
            }
            if (this.getRouteType() === 'city') {
                this.locationCatBdridge.setResultExp([]);
            }
        }
        if (this.isBrowser) {
            setTimeout(() => {
                this.requestListingRefresh();
            }, 0);
        }

    }

    onFiltering(event: any) {
        this.modelChanged2.next(event?.query);
        this.Query = event.query;
    }

    onEnter(event) {
        if (event.key !== 'Enter') {
            return;
        }
        // If suggestions are open and user pressed Enter without picking one,
        // use the first suggestion item (same as selecting it from the dropdown).
        const firstSuggestion = this.getFirstAutocompleteSuggestion();
        if (firstSuggestion) {
            this.onChangeSearch({ value: firstSuggestion });
            return;
        }

        // No suggestions — fall back to free-text title search
        this.onFilteringAfterDebounce(this.Query);
        this.searchedItem = this.Query;
        this.experienceDataChange.emit([]);
        if (this.currentComponentRoute.includes('/experience')) {
            this.searchedItemChange.emit(this.searchedItem);
            this.page = 1;
            this.last_page = 0;
            this.current_page = 0;
            this.bridgeService.setPage(1);
            this.bridgeService.setLastPage(0);
            this.bridgeService.setCurrentPage(0);
        }
        if (this.currentComponentRoute.includes('/gifts')) {
            this.page = 1;
            this.last_page = 0;
            this.current_page = 0;
            this.giftideaBridge.setPage(1);
            this.giftideaBridge.setLastPage(0);
            this.giftideaBridge.setCurrentPage(0);
        }
        if (this.currentComponentRoute.includes('/location-region') && this.getRouteType() === 'region') {
            this.type = '';
            this.page = 1;
            this.last_page = 0;
            this.current_page = 0;
            this.search_id = '';
            this.locationBridge.setType(this.type);
            this.locationBridge.setPage(this.page);
            this.locationBridge.setSearchedItem(this.Query);
            this.locationBridge.setLastPage(this.last_page);
            this.locationBridge.setCurrentPage(this.current_page);
            this.locationBridge.setSearchId(this.search_id);
        }
        if (this.currentComponentRoute.includes('/location-region') && this.getRouteType() === 'city') {
            this.search_id = '';
            this.type = '';
            this.page = 1;
            this.current_page = 0;
            this.locationCatBdridge.setResultExp([]);
            this.locationCatBdridge.setType(this.type);
            this.locationCatBdridge.setSearchId(this.search_id);
            this.locationCatBdridge.setPage(this.page);
            this.locationCatBdridge.setCurrentPage(this.current_page);
            this.locationCatBdridge.setSearchedItem(this.searchedItem);
        }
        if (this.isBrowser) {
            setTimeout(() => {
                this.requestListingRefresh();
            }, 10);
        }
    }

    /** First item across grouped autocomplete suggestions (for Enter without select). */
    private getFirstAutocompleteSuggestion(): any | null {
        if (this.filteredGroups?.length) {
            for (const group of this.filteredGroups) {
                if (group?.items?.length) {
                    return group.items[0];
                }
            }
        }
        if (this.autocompleteData?.length) {
            const raw = this.autocompleteData[0];
            return {
                id: raw.id,
                value: raw.value,
                label: raw.label,
                type: raw.type,
            };
        }
        return null;
    }

    onFilteringAfterDebounce(query: string) {
        let requestbody;
        if (this.currentComponentRoute.includes('/experience')) {
            const searchKeyword = query.trim();
            requestbody = { 'category_slug': this.slug, 'search': searchKeyword, 'category_type': 'higher-level-category' };
        }

        if (this.currentComponentRoute.includes('/gifts')) {
            const searchKeyword = query.trim();
            requestbody = {
                'category_slug': 'gift-ideas',
                'category_type': 'gift-ideas',
                'search': searchKeyword,
                'at_home': this.at_home,
                'location_slug': this.selected_location
            };
        }

        if (this.currentComponentRoute.includes('/gifts/')) {
            const searchKeyword = query.trim();
            requestbody = {
                'category_slug': this.slug,
                'category_type': 'gift-ideas',
                'search': searchKeyword,
                'at_home': this.at_home,
                'location_slug': this.selected_location,
                'price_option': this.price_filter_search
            };
        }

        if (this.currentComponentRoute.includes('/location-region')) {
            const searchKeyword = query.trim();
            console.log(this.getRouteType(), '============');
            if (this.getRouteType() === 'region') {
                requestbody = {
                    'search': searchKeyword,
                    'location_travel': this.location_travel,
                    'location': this.location,
                    'city': this.city,
                    'at_home': this.at_home,
                    'location_slug': this.slug,
                };
            }

            if (this.getRouteType() === 'city') {
                requestbody = {
                    search: searchKeyword,
                    location_slug: this.categorySlug,
                    // location_travel: this.location_travel,
                    // location: this.location,
                    // city: this.city,
                    // at_home: this.at_home
                };
            }

            this.addexperience.autocomplete_search(requestbody).subscribe(res => {
                if (res.response === 'success') {
                    if (this.isBrowser) {
                        setTimeout(() => {
                            this.autocompleteData = res.data;
                            this.groupItemsDynamically();
                        }, 10);
                    }
                }
            });
        }
        if (!this.currentComponentRoute.includes('/location-region')) {
            this.experienceService.getAutocompleteExperienceByCategory(requestbody, this.token).subscribe(res => {
                if (res.response === 'success') {
                    if (this.isBrowser) {
                        setTimeout(() => {
                            if (this.currentComponentRoute.includes('/experience')) {
                                this.autocompleteData = res.data;
                                this.groupItemsDynamically();
                            }
                            if (this.currentComponentRoute.includes('/gifts') || this.currentComponentRoute.includes('/gifts/')) {
                                this.filteredGroups = this.convertData(res.data);
                            }
                        }, 10);
                    }
                }
            });
        }
    }

    groupItemsDynamically() {
        const groups: { [key: string]: any } = {};
        if (this.autocompleteData.length > 0) {

            this.autocompleteData.forEach(item => {
                const groupKey = item.type;
                if (!groups[groupKey]) {
                    groups[groupKey] = {
                        label: `By ${item.type === 'category' ? 'Category' : 'Name'}`,
                        type: item.type,
                        items: []
                    }
                }
                groups[groupKey].items.push({ id: item.id, value: item.value, label: item.label, type: item.type });
            });
        }
        this.groupedData = Object.values(groups);
        this.filterGroupedCity()
    }

    filterGroupedCity() {
        let query = this.Query
        let filteredGroups = [];

        for (let optgroup of this.groupedData) {
            let filteredSubOptions = this.filterService.filter(optgroup.items, ['label'], query, "contains");
            if (filteredSubOptions && filteredSubOptions.length) {
                filteredGroups.push({
                    label: optgroup.label,
                    value: optgroup.value,
                    items: filteredSubOptions
                });
            }
        }
        this.filteredGroups = filteredGroups;
    }

    convertData(originalData) {
        const convertedData = [];
        // Group items by category
        var groupedItems
        if (Object.keys(originalData)?.length > 0) {
            groupedItems = originalData?.reduce((acc, item) => {
                if (!acc[item.category]) {
                    acc[item.category] = [];
                }
                acc[item.category].push({ label: item.label, value: item.value, id: item.id, type: item.type });
                return acc;
            }, {});
        }
        // Convert grouped items to the desired format
        for (const category in groupedItems) {
            const categoryItems = groupedItems[category];
            convertedData.push({
                label: category,
                value: category,
                items: categoryItems
            });
        }
        return convertedData;
    }

    getRouteType(): 'region' | 'city' {
        const segments = this.router.url.split('/').filter(Boolean)
        if (segments[0] === 'location-region' && (segments?.length === 3 || segments?.length === 2)) {
            return 'region';

        }
        else if (segments[0] === 'location-region' && segments.length === 4) {
            return 'city';
        }
    }

    private applyResolvedCategories(list: any[]): void {
        const url = this.router?.url || '';
        if (url.includes('/gifts')) {
            this.categoryList = list;
            return;
        }
        if (!this.highLevelCategoryList?.length) {
            this.highLevelCategoryList = list;
        }
        if (url.includes('/experience/')) {
            const slug = this.slug || this.route.snapshot.paramMap.get('slug') || '';
            const match = list.find((item) => item?.slug === slug);
            if (match?.child_categories?.length) {
                this.categoryList = match.child_categories;
            }
        }
    }

    get filteredCategoryList() {
        return this.categoryList?.filter(category => category.slug !== 'gift-ideas') || [];
    }

    preselectCountryFromSlug(slug: string) {
        // convert slug like "united-states" → "united states" catList
        const formatted = slug?.replace(/-/g, ' ').toLowerCase();

        const index = this.countries.findIndex(
            c => c.name.toLowerCase() === formatted || c.slug === slug
        );

        if (index !== -1) {
            // fire same logic as clicking by user
            this.selectedCountry(index, true);
        }
    }

    preselectCategoryFromSlug(slug: string) {
        // convert slug like "united-states" → "united states" catList
        const formatted = slug.replace(/-/g, ' ').toLowerCase();

        const index = this.catList.findIndex(
            c => c.name.toLowerCase() === formatted || c.slug === slug
        );

        if (index !== -1) {
            // fire same logic as clicking by user
            this.selectedHighLevelCategory(index, true);
        }
    }

    preselectGiftCategoryFromSlug(slug: string) {
        const formatted = slug.replace(/-/g, ' ').toLowerCase();
        let index = this.categoryList.findIndex(
            c => c.name.toLowerCase() === formatted || c.slug === slug
        );
        if (index !== -1) {
            index = index - 1;
            this.displayGiftCategorySelected(index);
        }
    }

    applyCountrySelection(index: number) {
        this.selectedCityIndex = null;
        this.citySelected = '';
        this.selectedCountry(index, false, true);
        setTimeout(() => {
            this.closeSelectLocationModal();
            this.updateParamsAndScroll();
        }, 1000);
    }

    applyChildSelection(countryIndex: number, childSlug: string) {
        this.selectedCountry(countryIndex, true, true);
        setTimeout(() => {
            const index = this.selectedChlidLocations.findIndex(
                (c: any) => c.slug === childSlug
            );
            if (index !== -1) {
                this.selectedLocation(index, true, true);
            }
        }, 0);
        setTimeout(() => {
            this.closeSelectLocationModal();
            this.updateParamsAndScroll();
        }, 1000);
    }

    setSelectedLoc() {
        if (this.isBrowser) {
            let loc_slug = '';
            if (this.selectedModalItem?.level === 1) {
                loc_slug = this.selectedModalItem?.slug;
            } else {
                loc_slug = this.selectedModalItem?.parentCountrySlug + '/' + this.selectedModalItem?.parentStateSlug;
            }
            sessionStorage.setItem('selected_loc_slug', loc_slug);
        }
    }

    onSelectFromModal() {
        this.isSelectedFromModal = true;
        this.setSelectedLoc();
        if (this.selectedModalItem?.level === 3) {
            this.selectedCity = this.selectedModalItem;
            this.selectedCountry(null, false, true);
            setTimeout(() => {
                this.closeSelectLocationModal();
                this.updateParamsAndScroll();
            }, 1000);
        } else {
            this.selectedCity = null;
            const selected = this.selectedModalItem;
            if (!selected) return;
            const countryIndex = selected.parentCountryIndex;
            if (selected.type === 'country') {
                this.applyCountrySelection(countryIndex);
            }
            else if (selected.type === 'state') {
                this.applyChildSelection(countryIndex, selected.slug);
            }


        }
    }

    filterLocations(event: any) {
        const query = event.query.toLowerCase();
        this.filteredModalLocationList = this.modalLocationList.filter(item =>
            item.name.toLowerCase().includes(query)
        );
    }

    shouldShowLocationModal(): boolean {
        if (!this.isBrowser) {
            return false;
        }
        try {
            const lastShown = localStorage.getItem(this.LOCATION_MODAL_LAST_SHOWN_KEY);
            if (!lastShown) {
                return true;
            }
            const lastShownTime = parseInt(lastShown, 10);
            if (isNaN(lastShownTime)) {
                return true;
            }
            const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
            return Date.now() - lastShownTime >= TWENTY_FOUR_HOURS;
        } catch (e) {
            console.error('Error reading location modal timestamp from localStorage:', e);
            return true;
        }
    }

    /**
     * Desktop (≥768): auto-open after 1.5s (unchanged).
     * Mobile (&lt;768): open on first scroll or tap instead.
     */
    private scheduleLocationModalPrompt(): void {
        if (!this.isBrowser) {
            return;
        }

        const hasCountry =
            this.bridgeService.countrySlug() != '' || this.giftCategory.country_slug() != '';
        if (hasCountry) {
            this.restoreSelectedModalItem();
            return;
        }
        if (!this.shouldShowLocationModal()) {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
        if (!isMobile) {
            setTimeout(() => {
                if (this.bridgeService.countrySlug() != '' || this.giftCategory.country_slug() != '') {
                    this.restoreSelectedModalItem();
                } else if (this.shouldShowLocationModal()) {
                    this.openSelectLocationModal();
                }
            }, 1500);
            return;
        }

        this.attachLocationModalEngageListeners();
    }

    private attachLocationModalEngageListeners(): void {
        if (this.locationModalEngageHandler) {
            return;
        }

        this.locationModalEngageHandler = () => {
            this.detachLocationModalEngageListeners();
            // Defer so the same tap's click does not hit the backdrop and close immediately.
            if (this.locationModalOpenDelayTimer) {
                clearTimeout(this.locationModalOpenDelayTimer);
            }
            this.locationModalOpenDelayTimer = setTimeout(() => {
                this.locationModalOpenDelayTimer = null;
                this.ngZone.run(() => {
                    if (this.bridgeService.countrySlug() != '' || this.giftCategory.country_slug() != '') {
                        this.restoreSelectedModalItem();
                        return;
                    }
                    this.openSelectLocationModal(true);
                    this.cdref.detectChanges();
                });
            }, 300);
        };

        const opts: AddEventListenerOptions = { passive: true, capture: true };
        document.addEventListener('scroll', this.locationModalEngageHandler, opts);
        window.addEventListener('scroll', this.locationModalEngageHandler, { passive: true });
        document.addEventListener('touchstart', this.locationModalEngageHandler, opts);
        document.addEventListener('pointerdown', this.locationModalEngageHandler, opts);
    }

    private detachLocationModalEngageListeners(): void {
        if (!this.locationModalEngageHandler || !this.isBrowser) {
            this.locationModalEngageHandler = null;
            return;
        }
        const handler = this.locationModalEngageHandler;
        const opts: AddEventListenerOptions = { capture: true };
        document.removeEventListener('scroll', handler, opts);
        window.removeEventListener('scroll', handler);
        document.removeEventListener('touchstart', handler, opts);
        document.removeEventListener('pointerdown', handler, opts);
        this.locationModalEngageHandler = null;
    }

    openSelectLocationModal(force: boolean = false): void {
        if (!this.isBrowser) return;

        if (!force && !this.shouldShowLocationModal()) {
            return;
        }

        this.detachLocationModalEngageListeners();
        this.restoreSelectedModalItem();
        this.isLocationModalOpen = true;
        this.suppressLocationOverlayCloseUntil = Date.now() + 600;
        document.body.style.overflow = 'hidden';
        this.attachLocationModalToBody();

        try {
            localStorage.setItem(this.LOCATION_MODAL_LAST_SHOWN_KEY, Date.now().toString());
        } catch (e) {
            console.error('Error saving location modal timestamp to localStorage:', e);
        }
    }

    clickOpenSelectLocationModal() {
        if (!this.isBrowser) return;

        this.detachLocationModalEngageListeners();
        this.restoreSelectedModalItem();
        this.isLocationModalOpen = true;
        this.suppressLocationOverlayCloseUntil = Date.now() + 600;
        document.body.style.overflow = 'hidden';
        this.attachLocationModalToBody();

        try {
            localStorage.setItem(this.LOCATION_MODAL_LAST_SHOWN_KEY, Date.now().toString());
        } catch (e) {
            console.error('Error saving location modal timestamp to localStorage:', e);
        }
    }

    /** Escape .exptravelCategory z-index:9 so overlay sits above the cookie banner. */
    private attachLocationModalToBody(): void {
        if (!this.isBrowser) {
            return;
        }
        const move = () => {
            const el = this.locationModalOverlay?.nativeElement;
            if (el && el.parentElement !== document.body) {
                document.body.appendChild(el);
            }
        };
        queueMicrotask(move);
        setTimeout(move, 0);
    }

    closeSelectLocationModal(): void {
        this.isLocationModalOpen = false;
        if (this.isBrowser) {
            document.body.style.overflow = '';
        }
    }

    onOverlayClick(event: MouseEvent): void {
        if (Date.now() < this.suppressLocationOverlayCloseUntil) {
            return;
        }
        if (!this.locationModalBox?.nativeElement.contains(event.target as Node)) {
            this.closeSelectLocationModal();
        }
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        if (this.isLocationModalOpen) this.closeSelectLocationModal();
    }

    removeCity(silent: boolean = false) {
        if (this.selectedCityIndex !== null) {
            this.removeLocDataFromnSession();
            this.selectedLocation(this.selectedCityIndex, false, false, silent);
        }
    }

    removeCountry(silent: boolean = false) {
        this.removeLocDataFromnSession();
        if (this.selectedCountryIndex !== null) {
            this.selectedCountry(this.selectedCountryIndex, false, false, silent);
        } else {
            if (this.selectedModalItem?.level === 3) {
                this.selectedModalItem = [];
                this.selectedCity = [];
                this.selectedCountry(null, false, false, silent);
            }
        }
    }

    removeHighLevelCategory(silent: boolean = false) {
        if (this.highLevelCategoryIndex !== null) {
            this.selectedHighLevelCategory(this.highLevelCategoryIndex, false, silent);
        }
    }

    removeSelectedCategoryName(silent: boolean = false) {
        //categoryIndex
        if (this.categoryIndex !== null) {
            this.selectedCategoryName = null;
            this.selectedCategoryfn(this.categoryIndex, silent);
        }
    }

    onCountrySelect(index) {
        this.removeLocDataFromnSession();
        this.selectedCountry(index);
        setTimeout(() => {
            this.updateParamsAndScroll();
        }, 1000);
    }

    onStateSelect(index) {
        this.removeLocDataFromnSession();
        this.selectedLocation(index);
        // setTimeout(() => {
        this.updateParamsAndScroll();
        // }, 1000);
    }

    selectedHighLevelCat(index) {
        this.selectedCategoryfn(index);
        setTimeout(() => {
            this.updateParamsAndScroll();
        }, 1000);
    }

    selectedGiftCat(index) {
        this.selectedHighLevelCategory(index);
        setTimeout(() => {
            this.updateParamsAndScroll();
        }, 1000);
    }

    removeLocDataFromnSession() {
        if (this.isBrowser) {
            if (sessionStorage.getItem('selected_loc_slug')) {
                sessionStorage.removeItem('selected_loc_slug');
            }
        }
    }

    readUrlForCountry(place: any) {
        if (this.isBrowser) {
            const path = window.location.pathname;
            const segments = path.split('/').filter(segment => segment.length > 0);

            if (segments.length >= 2) {
                const category = segments[1];
                const country = segments[2];
                const state = segments[3];
                if (country && country != '') {
                    if (state && state != '') {
                        this.safeReplaceState(`${this.currentComponentRoute}/${country}/${place}`);
                    } else {
                        this.safeReplaceState(`${path}/${place}`);
                    }
                } else {
                    this.safeReplaceState(`${this.currentComponentRoute}`);
                }
            }
        }
    }


    get resultsFrom(): number {
        if (!this.totalRecord || this.totalRecord <= 0) {
            return 0;
        }
        return this.first() + 1;
    }

    get resultsTo(): number {
        if (!this.totalRecord || this.totalRecord <= 0) {
            return 0;
        }
        return Math.min(this.first() + this.rows, this.totalRecord);
    }

    hasActiveFilters(): boolean {
        const hasCountry = !!(this.countrySelected || this.selectedCity);
        const hasCity = !!this.citySelected;
        const hasHigh = !!this.highLevelCatId;
        const hasCat = !!this.selectedCategoryName;
        const hasPrice = !!(this.price_option && this.price_option.length > 0);
        const hasBadge = !!(this.badge_id || this.selectedBadgeName);
        return hasCountry || hasCity || hasHigh || hasCat || hasPrice || hasBadge;
    }

    /** Up to 4 high-level categories shown as empty-state shortcuts */
    get emptyStateCategoryHints(): any[] {
        const list = Array.isArray(this.highLevelCategoryList) ? this.highLevelCategoryList : [];
        return list.filter((c) => !!(c?.name || c?.title)).slice(0, 4);
    }

    suggestEmptyStateCategory(cat: any) {
        const list = this.highLevelCategoryList || [];
        const index = list.findIndex((c) => c === cat || c?.id === cat?.id || c?.slug === cat?.slug);
        if (index < 0) {
            return;
        }
        // Selecting the same category again toggles it off — only apply when different
        if (this.highLevelCategoryIndex !== index) {
            this.selectedHighLevelCategory(index);
        }
    }

    openMapFromEmpty() {
        if (this.view_on_map) {
            return;
        }
        this.map_view({ target: { checked: true } });
    }

    clearAllFilters() {
        let needsRefresh = false;

        if (this.price_option && this.price_option.length > 0) {
            this.price_option = [];
            this.price_optionChange.emit(this.price_option);
            if (this.currentComponentRoute.includes('/experience')) {
                this.bridgeService.setPriceFilter(this.price_option);
            }
            if (this.currentComponentRoute.includes('/gifts') && !this.isGiftCategoryPage) {
                this.giftideaBridge.setPriceFilter(this.price_option);
            }
            if (this.isGiftCategoryPage) {
                this.giftCategory.setPriceFilter(this.price_option);
            }
            if (this.isLocationRegionPage) {
                this.locationBridge.setPriceFilter(this.price_option);
            }
            if (this.isLocationRegionCategoryPage) {
                this.locationCatBdridge.setPriceFilter(this.price_option);
            }
            needsRefresh = true;
        }

        if (this.badge_id || this.selectedBadgeName) {
            this.selectedBadgeIndex = null;
            this.selectedBadgeName = null;
            this.badge_id = '';
            this.badge_idChange.emit('');
            this.syncBadgeQueryParam();
            needsRefresh = true;
        }

        // Clear every active dimension in one pass (silent = no per-step API calls).
        if (!this.isGiftCategoryPage && this.selectedCategoryName) {
            this.removeSelectedCategoryName(true);
            needsRefresh = true;
        }
        if (!this.isHighLevelCategoryPage && this.highLevelCatId) {
            this.removeHighLevelCategory(true);
            needsRefresh = true;
        }
        if (this.citySelected) {
            this.removeCity(true);
            needsRefresh = true;
        }
        // Clear country on category/gift/experience filters. On location-region the
        // country is the page identity, but still clear the sidebar chip + place.
        if (this.countrySelected || this.selectedCity) {
            if (!this.isLocationRegionPage) {
                this.removeCountry(true);
                needsRefresh = true;
            } else if (this.selectedCountryIndex !== null || this.countrySelected) {
                // Drop sidebar country highlight without leaving the region page.
                this.selectedCountryIndex = null;
                this.countrySelected = '';
                this.selectedCity = [];
                this.selectedModalItem = [];
                needsRefresh = true;
            }
        }

        if (needsRefresh) {
            this.updateParamsAndScroll();
            this.requestListingRefresh({ resetPage: true });
        }
    }

    ngOnDestroy(): void {
        this.viewInitialized = false;
        this.breakpointSubs.forEach(sub => sub.unsubscribe());
        this.breakpointSubs = [];
        this.detachLocationModalEngageListeners();
        if (this.locationModalOpenDelayTimer) {
            clearTimeout(this.locationModalOpenDelayTimer);
            this.locationModalOpenDelayTimer = null;
        }
        if (this.isBrowser) {
            this.unbindMapStickyListeners();
            this.clearMapStickyPosition();
            document.body.classList.remove('menu-opened');
            document.body.classList.remove('spur-map-view-active');
            document.body.classList.remove('mapfixed');
            document.body.classList.remove('exp-filter-pin-page');
            document.body.style.overflow = '';
            const overlayEl = this.locationModalOverlay?.nativeElement;
            if (overlayEl?.parentElement === document.body) {
                overlayEl.remove();
            }
        }
        this.closeMapPinPopover();
        this.clearMapFitTimers();
        this.clearMapSearchDebounce();
        this.teardownMapResizeGuard();
        this.detachMapMoveSearchListener();
        if (this.mapPixelOverlay) {
            this.mapPixelOverlay.setMap(null);
            this.mapPixelOverlay = null;
        }
        if (this.locationData) {
            this.locationData.unsubscribe();
        }

        if (this.categoryData) {
            this.categoryData.unsubscribe();
        }
        this.page = 1;
        this.last_page = 1;
        this.current_page = 1;
        this.price_filter_search = [];
        this.price_option = [];
        this.price_optionChange.emit([]);
        this.at_home = false;
        this.selectedCountryIndex = null;
        this.countrySelected = '';
        this.selectedCityIndex = null;
        this.citySelected = '';
        this.selectedChlidLocations = [];
        this.selectedCategory = "";
        this.selectedCategoryIndex = null;
        this.categoryIndex = '';
        this.highLevelCategoryIndex = null;
        this.highLevelCatId = 0;
        this.search_id = null;
        this.type = "";
        this.selected_location = "";
        // this.country_slug = '';
        // this.state_slug = '';
        this.bridgeService.setSelectedLocation("");
        this.bridgeService.setAtHome(false);
        this.bridgeService.setPage(1);
        this.bridgeService.setLastPage(0);
        this.bridgeService.setCurrentPage(0);
        this.bridgeService.setType('');
        this.bridgeService.setSearchId('');
        this.bridgeService.setPriceFilter([]);
        this.bridgeService.setExpData([]);
        this.bridgeService.setSlug('');
        this.bridgeService.setState('');
        this.bridgeService.setCountrySlug('');
        this.bridgeService.setCategorySlug('')


        this.giftCategory.setSelectedLocation("");
        this.giftCategory.setAtHome(false);
        this.giftCategory.setPage(1);
        this.giftCategory.setLastPage(0);
        this.giftCategory.setCurrentPage(0);
        this.giftCategory.setType('');
        this.giftCategory.setSearchId('');
        this.giftCategory.setPriceFilter([]);
        this.giftCategory.setCategorySlug('');
        this.giftCategory.setCountrySlug('');
        this.giftCategory.setSlug('');
        this.giftCategory.setState('');


        this.giftideaBridge.setSelectedLocation("");
        this.giftideaBridge.setAtHome(false);
        this.giftideaBridge.setPage(0);
        this.giftideaBridge.setLastPage(0);
        this.giftideaBridge.setCurrentPage(0);
        this.giftideaBridge.setType('');
        this.giftideaBridge.setSearchId('');
        this.giftideaBridge.setPriceFilter([]);
        this.giftideaBridge.setCategorySlug('');
        this.giftideaBridge.setExpData([]);

        this.locationBridge.setPage(1);
        this.locationBridge.setLastPage(0);
        this.locationBridge.setCurrentPage(0);
        this.locationBridge.setType('');
        this.locationBridge.setSearchId('');
        this.locationBridge.setSearchedItem('');
        this.locationBridge.setResult([]);
        this.locationBridge.setCategoryId(0);
        this.locationBridge.setAtHome(false);
        this.locationBridge.setPlaceSlug('');
        this.locationBridge.setPriceFilter([]);

        this.locationCatBdridge.setAtHome(false);
        this.locationCatBdridge.setPage(1);
        this.locationCatBdridge.setCurrentPage(0);
        this.locationCatBdridge.setType('');
        this.locationCatBdridge.setSearchId('');
        this.locationCatBdridge.setSearchedItem('');
        this.locationCatBdridge.setResultExp([]);
        this.locationCatBdridge.setCategoryId(0);
        this.locationCatBdridge.setCity('');
        this.locationCatBdridge.setState('');
        this.locationCatBdridge.setPriceFilter([]);
        // this.locationCatBdridge.setCategorySlug('')
    }
}